import * as React from 'react';
import axios from 'axios';
import authService from './api-authorization/AuthorizeService';
import { toast } from 'react-toastify';
import * as _ from 'lodash';
import Modal from 'react-bootstrap/Modal';
import NotesPopup from './NotesPopup';
import JobQuoteCalculatorModal from './JobQuoteCalculatorModal';
import JobQuoteWalkWayModal from './JobQuoteWalkWayModal';
import QuoteSiteNotePopup from './JobQuoteSiteNoteModal';
import QuoteNotePopup from './JobQuoteNoteModal';
import ConfirmPopups from './ConfirmPopup';
import JobQuoteExtraItemModal from './JobQuoteExtraItemModal';
import JobQuoteExtraSectionData from './JobQuoteExtraSectionModal';
import AllocateScheduleJobPopup from './AllocateScheduleJobModal';
import JobQuoteQuestionsData from './JobQuoteQuestions';
import JobQuoteExtraTrolleyData from './JobQuoteExtraTrolleyModal';
import JobQuoteExtraInvoiceItemModal from './JobQuoteExtraInvoiceItemsModal';
import JobQuoteDeliveryAddressData from './JobQuoteDeliveryAddressModal';
import JobQuoteBraceModal from './JobQuoteBraceModal';
import JobQuoteEpaQuestionsModalData from './JobQuoteEpaQuestionsModal';

interface JobQuoteProps {
    jobId: number;
    systemCompanyId: number;
    siteAddress: string;
    customerId?: number;
    jobTypeId: number;
    copyJob(): void;
    veiwQuoteHistory(tab: string): void;
}

interface JobQuotes {
    chargeFuelSurcharge: boolean;
    quoteDetails: JobQuoteDetails,
    useCustomPriceList: boolean;
    showCancelledItems: boolean;
    plans: PlanFile[];
    showDeletePlan: boolean;
    deletePlanId: number;
    siteVisitPersonOptions: GenericList[];
    itemOptions: ItemOptionList[];
    frequencyOptions: GenericList[];
    statusOptions: GenericList[];
    cancelOptions: GenericList[];
    starterBayOptions: GenericList[];
    liftOptions: GenericList[];
    kwikstageInstalledForOptions: GenericList[];
    yesNoOptions: GenericList[];
    truckOptions: GenericList[];
    truckSideOptions: GenericList[];
    towerSizeOptions: number[];
    quoteRowCount: number;
    showCancelModal: boolean;
    cancelItem: string;
    cancelItemIndexId: number;
    cancelReasonId: number;
    gst: number;
    showEditNotesModal: boolean;
    editNotes: EditNotes;
    showCalculator: boolean;
    calculatorIndex: number;
    calculatorKwikstageItem: KwikstageItem;
    calculatorItems: KwikstageCalculation[];
    calculatorStatusId: number;
    walkWayItem: WalkWayItem;
    showWalkwayPitch: boolean;
    walkwayIndexId: number;
    walkwayStatusId: number;
    showQuoteNote: boolean;
    quoteNoteIndex: number;
    quoteNote: string;
    showAddSiteNotes: boolean;
    siteNotes: GenericList[];
    distance: string;
    showExtraItems: boolean;
    editExtraItems: boolean;
    extraIndex: number;
    extras: NewJobQuoteItemExtra;
    extraItemOptions: JobQuoteExtraItemOption[];
    itemDescription: string;
    tables: number;
    chairs: number;
    siteOfficeExtraId: number;
    lunchRoomExtraId: number;
    showExtraSection: boolean;
    extraSection: JobQuoteExtraSection;
    showScheduleJob: boolean;
    scheduleItemDetail: ScheduleItemDetail;
    scheduleJobNeedsPickup: boolean;
    defaultDays: number;
    customerAccountTypeId: number;
    customerAccountType: string;
    customerAccountLimitFormatted: string; 
    customerLinkedToReckon: boolean;
    customerNewFuelInvoice: boolean;    //customer needs different po for fuel surcharge
    showPowerPoleQuestions: boolean;
    powerPoleItemId: number;
    powerPoleCanEdit: boolean;
    showEpaQuestions: boolean;
    itemTypeId: number;
    showExtraTrolley: boolean;
    extraTrolley: boolean;
    showExtraInvoiceItems: boolean;
    extraInvoiceItemQuoteId: number;    //setting it when viewing the item rather than loading when quote loads
    showInvoiceDescription: boolean;
    jobQuoteItemId: number;
    itemId: number;
    existInvoiceDescription: string;
    trolley: boolean;
    editTrolleyReadOnly: boolean;
    showFenceBracing: boolean;
    fenceArea: string;      //will just save this if it isn't empty
    epaTruckHireRate: number;
    epaConfinedSpacePrice: number;
    weekendRate: number;
    sameDayRate: number;
    saveDisabled: boolean;
    errors: any;
    loading: boolean;
    gridLoading: boolean;
}

interface ScheduleItemDetail {
    jobId: number;
    jobQuoteItemId: number;
    item: string;
    itemTypeId: number;
    installOnly: boolean;
    isEvent: boolean;
    needsPickup: boolean;
    hirePeriod: number;
    frequencyId: number;
    customerAccountTypeId: number;
    customerLinkedToReckon: boolean;
    siteContact: string;
    jobOnHold: boolean;
}

interface NewJobQuoteItemExtra {
    itemId: number;
    quantity: number;
    equipped: boolean;
}

interface JobQuoteExtraItemOption {
    id: number;
    name: string;
    tableDesk: number;
    chairs: number;
}

interface JobQuoteExtraSection {
    totalLength: number;
    crossoverQuantity: number;
    sectionQuantity: number;
    totalCrossoverLength: string;
}

interface JobQuoteDetails {
    id: number;
    quoteNo: number;
    manualQuoteNumber: string;
    jobId: number;
    isEvent: boolean;
    requireSiteVisit: boolean;
    siteVisitPerson: number;
    siteContactName: string;
    siteContactPhone: string;
    showSiteVisitNote: boolean;
    totalQuotedAmount: number;
    totalQuotedAmountFormatted: string;
    totalInvoiceExtraAmount: number;
    totalInvoiceExtraAmountFormatted: string;
    totalInvoiceAmount: number;
    totalInvoiceAmountFormatted: string;
    jobQuoteItems: JobQuoteItems[];
    quoteNotes: string;
    siteAddressDuration: number;
    customerPickingUp: number;
    isDirty: boolean;
}

interface JobQuoteItems {
    itemIndex: number;
    id: number;
    itemId: number;
    item: string;
    itemDescription: string;
    installOnly: boolean;
    extendable: boolean;
    invoiceDescription: string;
    typeId: number;
    productGroupId: number;
    steepRoofPitch: number;
    isVoid: boolean;
    isTower: boolean;
    isWalkWay: boolean;
    unitOfMeasure: string;
    status: string;
    statusId: number;
    hirePeriod: number;
    defaultHirePeriod: number;
    customHirePeriod: boolean;
    hirePeriodWeeksDesc: string;
    frequencyId: number;
    locationId: number;
    fenceBraceId: number;
    size: number;
    includeInstallDismantle: number;
    quantity: number;
    initialHire: number;
    travelAmount: number;
    cleaningFee: number;
    trenchFee: number;
    confinedSpaceAmount: number;
    sampleTestingAmount: number;
    wasteDisposalAmount: number;
    fuelSurchargeAmount: number;
    extraHours: number;
    kwikstageInstalledForId: number;
    rate: number;
    gst: number;
    amount: number;
    overhireRate: number;
    estCostPriceFormatted: string;
    estMarginFormatted: string;
    estMarginPercentageFormatted: string;
    callout: boolean;
    notes: string;
    quoteNote: string;  //max 20 chars to go on the quote under the item name
    canEditTravel: boolean;
    linkedId: number;
    itemOrder: number;
    showOnQuote: boolean;
    isEws: boolean;
    isEvent: boolean;
    truckId: number;
    truckDoorsId: number;
    trolley: boolean;
    extras: NewJobQuoteItemExtra;
    incStepsTravel: boolean;    //if item is steps and this one includes the travel for all step items
    invoicePeriodTypeId: number;    //1 = Weeks, 2 = Months
    tankLidExposed: boolean;
    weekendJob: boolean;
    emergencySameDayJob: boolean;
    epaQuestionsAnswered: boolean;
    isDirty: boolean;
}

interface NewJobQuoteItemExtra {
    itemId: number;
    quantity: number;
    equipped: boolean;
}
//extras / equipped amount is stored against the item so user can update it. This will then be saved into the extras table for the initial invoice

interface GenericList {
    id: number;
    name: string;
}

interface ItemOptionList {
    id: number;
    name: string;
    description: string;
    unitOfMeasure: string;
    chargeGst: boolean;
    callout: boolean;
    priceListItem: boolean;
    priceListDefaultDays: number;
    isWalkWay: boolean;
    typeId: number;
    installOnly: boolean;
    isEws: boolean;
    isEvent: boolean;
    defaultTruckId: number;
    extendable: boolean;
    invoicePeriodTypeId: number;    //1 = Weeks, 2 = Months
    productGroupId: number;         //Toilets, Fencing, P&C, EWS, EPA etc
}

interface QuoteItemNotes {
    id: number;
    jobId: number;
    itemId: number;
    notes: string;
    quoteNote: string;
    subId: string;
};

interface EditNotes {
    heading: string;
    rowIndex: number;
    parentIndex: number;
    id: number;
    itemId: number;
    item: string;
    notes: string;
}

interface KwikstageItem {
    extraHours: number;
    kwikstageInstalledFor: number;
    quoteNote: string;
}

interface KwikstageCalculation {
    id: number;
    starterBayId: number;
    liftId: number;
    bays: number;
    baysRemaining: number;
}

interface WalkWayItem {
    id: number;
    steepRoofPitch: number;
    quantity: number;
    extraHours: number;
    quoteNote: string;
}

interface PlanFile {
    id: number;
    fileName: string;
}

interface DeliveryAddress {
    deliveryAddress: string;
    deliveryAddressGooglePlaceId: string;
    deliveryAddressLatitude: number;
    deliveryAddressLongitude: number;
};

interface RateGst {
    rate: number,
    gst: number
};

export default class JobQuote extends React.Component<JobQuoteProps, JobQuotes> {
    constructor(props: JobQuoteProps) {
        super(props);
        this.state = {
            chargeFuelSurcharge: true,
            quoteDetails: {
                id: 0,
                jobId: props.jobId,
                quoteNo: 0,
                manualQuoteNumber: "",
                isEvent: false,
                requireSiteVisit: false,
                siteVisitPerson: -1,
                siteContactName: "",
                siteContactPhone: "",
                showSiteVisitNote: true,
                totalQuotedAmount: 0,
                totalQuotedAmountFormatted: "$0.00",
                totalInvoiceExtraAmount: 0,
                totalInvoiceExtraAmountFormatted: "$0.00",
                totalInvoiceAmount: 0,
                totalInvoiceAmountFormatted: "$0.00",
                quoteNotes: "",
                siteAddressDuration: 0,
                customerPickingUp: 0,
                isDirty: false,
                jobQuoteItems: [{
                    itemIndex: 0,   //used to update items in the array as may have multiple items with id of 0
                    id: 0,
                    itemId: -1,
                    item: "",
                    itemDescription: "",
                    installOnly: false,
                    extendable: true,
                    invoiceDescription: "",
                    typeId: -1,
                    productGroupId: 0,
                    steepRoofPitch: 0,
                    isWalkWay: false,
                    isVoid: false,
                    isTower: false,
                    unitOfMeasure: "",
                    status: "Quoted",
                    statusId: 1,
                    hirePeriod: 0,
                    defaultHirePeriod: 0,
                    customHirePeriod: false,
                    hirePeriodWeeksDesc: "",
                    frequencyId: -1,
                    locationId: -1,
                    fenceBraceId: -1,
                    size: 0,
                    includeInstallDismantle: 0,
                    quantity: 0,
                    initialHire: 0,
                    travelAmount: 0,
                    cleaningFee: 0,
                    trenchFee: 0,
                    confinedSpaceAmount: 0,
                    sampleTestingAmount: 0,
                    wasteDisposalAmount: 0,
                    fuelSurchargeAmount: 0,
                    extraHours: 0,
                    kwikstageInstalledForId: -1,
                    rate: 0,
                    gst: 0,
                    amount: 0,
                    overhireRate: 0,
                    estCostPriceFormatted: "$0.00",
                    estMarginFormatted: "$0.00",
                    estMarginPercentageFormatted: "0%",
                    callout: false,
                    notes: "",
                    quoteNote: "",
                    linkedId: 0,
                    canEditTravel: true,
                    itemOrder: 1,
                    showOnQuote: true,
                    isEws: false,
                    isEvent: false,
                    truckId: -1,
                    truckDoorsId: -1,
                    trolley: false,
                    extras: {
                        itemId: -1,
                        quantity: 0,
                        equipped: false
                    },
                    incStepsTravel: false,
                    invoicePeriodTypeId: 1,
                    tankLidExposed: false,
                    weekendJob: false,
                    emergencySameDayJob: false,
                    epaQuestionsAnswered: false,
                    isDirty: false
                }]
            },
            useCustomPriceList: false,
            showCancelledItems: false,
            plans: [],
            showDeletePlan: false,
            deletePlanId: 0,
            siteVisitPersonOptions: [],
            itemOptions: [],
            frequencyOptions: [],
            statusOptions: [],
            cancelOptions: [],
            starterBayOptions: [],
            liftOptions: [],
            kwikstageInstalledForOptions: [],
            yesNoOptions: [],
            truckOptions: [],
            truckSideOptions: [],
            towerSizeOptions: [],
            cancelItem: "",
            cancelItemIndexId: -1,
            cancelReasonId: -1,
            showCancelModal: false,
            quoteRowCount: 0,
            gst: 0,
            showEditNotesModal: false,
            editNotes: {
                heading: "",
                rowIndex: 0,
                parentIndex: 0,
                id: 0,
                item: "",
                itemId: 0,
                notes: ""
            },
            showCalculator: false,
            calculatorIndex: -1,
            calculatorKwikstageItem: {
                extraHours: 0,
                kwikstageInstalledFor: -1,
                quoteNote: ""
            },
            calculatorItems: [],
            calculatorStatusId: 0,
            walkWayItem: {
                id: 0,
                quantity: 0,
                steepRoofPitch: 0,
                extraHours: 0,
                quoteNote: ""
            },
            showWalkwayPitch: false,
            walkwayIndexId: 0,
            walkwayStatusId: 0,
            showQuoteNote: false,
            quoteNoteIndex: -1,
            quoteNote: "",
            showAddSiteNotes: false,
            siteNotes: [],
            saveDisabled: false,
            distance: "",
            extraItemOptions: [],
            showExtraItems: false,
            editExtraItems: false,
            extraIndex: -1,
            extras: {
                itemId: -1,
                quantity: 0,
                equipped: false
            },
            itemDescription: "",
            tables: 1,
            chairs: 2,
            lunchRoomExtraId: 0,
            siteOfficeExtraId: 0,
            showExtraSection: false,
            extraSection: {
                totalLength: 0,
                crossoverQuantity: 0,
                sectionQuantity: 0, 
                totalCrossoverLength: "0.0"
            },
            showScheduleJob: false,
            scheduleItemDetail: {
                jobId: 0,
                jobQuoteItemId: 0,
                item: "",
                itemTypeId: 0,
                installOnly: false,
                isEvent: false,
                needsPickup: false,
                hirePeriod: 0,
                frequencyId: 0,
                customerAccountTypeId: 0,
                customerLinkedToReckon: true,
                siteContact: "",
                jobOnHold: false
            },
            scheduleJobNeedsPickup: false,
            defaultDays: 0,
            customerAccountTypeId: 0,
            customerAccountType: "",
            customerAccountLimitFormatted: "$0.00",
            customerLinkedToReckon: true,
            customerNewFuelInvoice: false,
            showPowerPoleQuestions: false,
            powerPoleItemId: -1,
            powerPoleCanEdit: false,
            showEpaQuestions: false,
            itemTypeId: -1,
            showExtraTrolley: false,
            extraTrolley: false,
            showExtraInvoiceItems: false,
            extraInvoiceItemQuoteId: 0,
            showInvoiceDescription: false,
            jobQuoteItemId: 0,
            itemId: 0,
            existInvoiceDescription: "",
            trolley: false,
            editTrolleyReadOnly: false,
            showFenceBracing: false,
            fenceArea: "",
            epaTruckHireRate: 0,
            epaConfinedSpacePrice: 0,
            weekendRate: 0,
            sameDayRate: 0,
            errors: {},
            loading: true,
            gridLoading: true
        }
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/Job/GetQuoteDropdowns?JobId=' + this.props.jobId + '&CustomerId=' + this.props.customerId + '&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({
                chargeFuelSurcharge: res.data.chargeFuelSurcharge,
                extraItemOptions: res.data.extraItemOptions, siteOfficeExtraId: res.data.siteOfficeExtraId, lunchRoomExtraId: res.data.lunchRoomExtraId,
                siteVisitPersonOptions: res.data.jobSiteVisitPersonList, itemOptions: res.data.jobQuoteItemList, frequencyOptions: res.data.frequencyOptions, gst: res.data.gst, yesNoOptions: res.data.yesNoOptions,
                useCustomPriceList: res.data.useCustomPriceList, liftOptions: res.data.liftOptions, starterBayOptions: res.data.starterBayOptions, scheduleJobNeedsPickup: !res.data.allowOnGoingHire,
                kwikstageInstalledForOptions: res.data.kwikstageInstalledForOptions, truckOptions: res.data.truckOptions, truckSideOptions: res.data.truckSideOptions, towerSizeOptions: res.data.towerSizeOptions, defaultDays: res.data.defaultDays,
                customerAccountTypeId: res.data.accountTypeId, customerAccountType: res.data.accountType, customerAccountLimitFormatted: res.data.accountLimitFormatted, customerLinkedToReckon: res.data.customerLinkedToReckon, customerNewFuelInvoice: res.data.customerNewFuelInvoice,
                epaTruckHireRate: res.data.epaTruckHireRate, epaConfinedSpacePrice: res.data.epaConfinedSpacePrice, weekendRate: res.data.weekendRate, sameDayRate: res.data.sameDayRate
            });
            this.getQuote();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    async getQuote() {
        const token = await authService.getAccessToken();
        var jobId = this.props.jobId;

        axios.get('api/Job/GetQuote?jobId=' + jobId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.jobQuote.quoteNo) {
                var quoteDetails: JobQuoteDetails = res.data.jobQuote;
                if (!quoteDetails.requireSiteVisit) {
                    quoteDetails.siteVisitPerson = -1;
                }
                //add item index to quote items
                for (var i = 0; i < quoteDetails.jobQuoteItems.length; i++) {
                    quoteDetails.jobQuoteItems[i].itemIndex = i;
                    quoteDetails.jobQuoteItems[i].hirePeriod = quoteDetails.jobQuoteItems[i].customHirePeriod && quoteDetails.jobQuoteItems[i].invoicePeriodTypeId === 1 ? quoteDetails.jobQuoteItems[i].hirePeriod / 7 : quoteDetails.jobQuoteItems[i].hirePeriod;
                }

                //add new row to quote detail items
                if (this.props.jobTypeId === 1 || this.props.jobTypeId === 3) {
                    let filteredItems = quoteDetails.jobQuoteItems.filter(data =>
                        data.status != "Cancelled"
                    );
                    var blankLine = this.addBlankLine(quoteDetails.jobQuoteItems.length, filteredItems.length);
                    quoteDetails.jobQuoteItems.push(blankLine);
                }

                this.setState({
                    quoteDetails: quoteDetails, plans: res.data.plans, loading: false, gridLoading: false, saveDisabled: false
                });
            } else {
                this.setState({ loading: false, gridLoading: false, saveDisabled: false });
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    async getQuotePlans() {
        const token = await authService.getAccessToken();
        var jobId = this.props.jobId;

        axios.get('api/Job/GetJobQuotePlans?jobId=' + jobId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ plans: res.data });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    addBlankLine = (itemIndex: number, itemOrder: number) => {
        var qty = this.props.systemCompanyId === 3 ? 1 : 0;     //may need to change this for fencing

        var newLine: JobQuoteItems = {
            itemIndex: itemIndex,
            id: 0,
            itemId: -1,
            item: "",
            itemDescription: "",
            installOnly: false,
            extendable: true,
            invoiceDescription: "",
            typeId: -1,
            productGroupId: 0,
            steepRoofPitch: 0,
            isWalkWay: false,
            isVoid: false,
            isTower: false,
            unitOfMeasure: "",
            status: "Quoted",
            statusId: 1,
            hirePeriod: 0,
            defaultHirePeriod: 0,
            customHirePeriod: false,
            hirePeriodWeeksDesc: "",
            frequencyId: -1,
            locationId: -1,
            fenceBraceId: -1,
            size: 0,
            includeInstallDismantle: 0,
            quantity: qty,
            initialHire: 0,
            travelAmount: 0,
            cleaningFee: 0,
            trenchFee: 0,
            confinedSpaceAmount: 0,
            sampleTestingAmount: 0,
            wasteDisposalAmount: 0,
            fuelSurchargeAmount: 0,
            extraHours: 0,
            kwikstageInstalledForId: -1,
            rate: 0,
            gst: 0,
            amount: 0,
            overhireRate: 0,
            estCostPriceFormatted: "$0.00",
            estMarginFormatted: "$0.00",
            estMarginPercentageFormatted: "0%",
            callout: false,
            notes: "",
            quoteNote: "",
            linkedId: 0,
            canEditTravel: true,
            itemOrder: itemOrder + 1,
            showOnQuote: true,
            isEws: false,
            isEvent: false,
            truckId: -1,
            truckDoorsId: -1,
            trolley: false,
            extras: {
                itemId: -1,
                quantity: 0,
                equipped: false
            },
            incStepsTravel: false,
            invoicePeriodTypeId: 1,
            tankLidExposed: false,
            weekendJob: false,
            emergencySameDayJob: false,
            epaQuestionsAnswered: false,
            isDirty: false
        };

        return newLine;
    }

    //history screen
    viewQuoteHistory = (e: any) => {
        e.preventDefault();

        this.props.veiwQuoteHistory("QuoteHistory");
    }
    //end history

    sendSiteVisitEmail = (e: any) => {
        e.preventDefault();

        this.sendSiteEmail();
    }

    async sendSiteEmail() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var jobId = this.props.jobId;
        var siteVisitPersonId = this.state.quoteDetails.siteVisitPerson;
        axios.get('api/Job/SendQuoteSiteVisitEmail?jobId=' + jobId + '&siteVisitUserId=' + siteVisitPersonId + '&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Email has been sent");
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleChange = (e: any) => {
        let quote: any = {};
        quote = this.state.quoteDetails;
        quote[e.target.name] = e.target.value;
        quote.isDirty = true;
        this.setState({ quoteDetails: quote, saveDisabled: false });
    }

    handleCustPickupChange = (e: any) => {
        let quote: any = {};
        quote = this.state.quoteDetails;
        let value = e.target.value * 1;
        quote[e.target.name] = value;
        quote.isDirty = true;

        //update travel to $0 if customer picking up otherwise re-calculate price
        let quoteItems: JobQuoteItems[] = quote.jobQuoteItems;
        for (var i = 0; i < quoteItems.length; i++) {
            let quoteItem = quoteItems[i];
            if (value === 1) {
                quoteItem.travelAmount = 0;
                quoteItem.amount = quoteItem.initialHire + quoteItem.cleaningFee + quoteItem.trenchFee;
            } else {
                this.calcQuotePrice(quote, quoteItem);
            }
        }

        this.setState({ quoteDetails: quote, saveDisabled: false });
    }

    handleCheckboxChange = (e: any) => {
        //if checked - show select person, if unchecked clear person
        let change: any = {};
        change[e.target.name] = e.target.checked;
        this.setState(change)
    }

    handleSiteVisitCheckboxChange = (e: any) => {
        //if checked - show select person, if unchecked clear person
        var quote = this.state.quoteDetails;
        quote.requireSiteVisit = e.target.checked;
        quote.siteVisitPerson = -1;
        this.setState({ quoteDetails: quote, saveDisabled: false });
    }

    handleSiteVisitNoteChange = (e: any) => {
        var quote = this.state.quoteDetails;
        quote.showSiteVisitNote = e.target.checked;
        this.setState({ quoteDetails: quote, saveDisabled: false });
    }

    //WALKWAY
    checkWalkWayPitch = (e: any, itemIndex: number) => {
        e.preventDefault();
        var quote = this.state.quoteDetails;
        var quoteItem = quote.jobQuoteItems[itemIndex];

        if (quoteItem.isWalkWay) {
            //check pitch
            var walkWayItem: WalkWayItem = {
                id: quoteItem.id,
                quantity: quoteItem.quantity,
                steepRoofPitch: quoteItem.steepRoofPitch,
                extraHours: quoteItem.extraHours,
                quoteNote: quoteItem.quoteNote
            };

            this.setState({ walkWayItem: walkWayItem, showWalkwayPitch: true, walkwayStatusId: quoteItem.statusId, walkwayIndexId: itemIndex, saveDisabled: false });
        } else if (quoteItem.typeId === 27) {
            this.calculateCrossoverQuantity(e, itemIndex);
        }
    }

    hideWalkWayPitch = () => {
        let walkWayItem = this.resetWalkWayItem();
        this.setState({ walkWayItem: walkWayItem, showWalkwayPitch: false, walkwayStatusId: 0, walkwayIndexId: -1 });
    }

    updateWalkWayPitch = (walkWayayItem: WalkWayItem) => {
        this.setState({ walkWayItem: walkWayayItem });
    }

    resetWalkWayItem = () => {
        var walkWayItem: WalkWayItem = {
            id: 0,
            quantity: 0,
            steepRoofPitch: 0,
            extraHours: 0,
            quoteNote: ""
        };

        return walkWayItem;
    }

    saveWalkWayPitch = () => {
        this.saveWalkWayPitchItem();
    }

    async saveWalkWayPitchItem() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var quote = this.state.quoteDetails;
        var quoteItems = quote.jobQuoteItems;
        var quoteItem = quoteItems[this.state.walkwayIndexId];
        //update quote item from walkway options
        var walkWayItem = this.state.walkWayItem;
        quoteItem.quantity = walkWayItem.quantity;
        quoteItem.extraHours = walkWayItem.extraHours;
        quoteItem.steepRoofPitch = walkWayItem.steepRoofPitch;
        quoteItem.quoteNote = walkWayItem.quoteNote;

        //calc price
        var itemOption = _.find(this.state.itemOptions, { 'id': quoteItem.itemId * 1 });
        var chargeGst = itemOption?.chargeGst;

        var wwItem = {
            jobId: this.props.jobId,
            customerId: this.props.customerId,
            useCustomPriceList: this.state.useCustomPriceList,
            chargeGst: chargeGst,
            walkWayItem: quoteItem,
            jobQuoteId: quote.quoteNo,
            itemOrder: quoteItem.itemOrder,
            chargeFuelSurcharge: this.state.chargeFuelSurcharge,
            subId: user.sub
        };

        axios.post('api/Job/CalculateWalkWayQuotePrice', wwItem, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            let newquoteItem = res.data.walkWayItem;
            newquoteItem.itemIndex = this.state.walkwayIndexId;
            quoteItems.splice(this.state.walkwayIndexId, 1, newquoteItem);
            var wwRaise = res.data.walkWayRaiseItem;
            if (wwRaise) {
                //check if wwRaise already exists and just needs updating
                var existIndex = quote.jobQuoteItems.findIndex(jqi => jqi.id === wwRaise.id);
                if (existIndex < 0 || wwRaise.id === 0) {
                    //add new raise
                    //insert the raise before the blank new row
                    var indexToInsert = quote.jobQuoteItems.length - 1;
                    wwRaise.itemIndex = indexToInsert;
                    indexToInsert = indexToInsert < 0 ? 0 : indexToInsert;
                    quote.jobQuoteItems.splice(indexToInsert, 0, wwRaise);
                    //update blank new row with next itemindex
                    var blankRowIndex = quote.jobQuoteItems.length - 1;
                    var blankRow = quote.jobQuoteItems[blankRowIndex];
                    if (blankRow) {
                        blankRow.itemIndex = (indexToInsert + 1);
                        blankRow.itemOrder = wwRaise.itemOrder + 1;
                    }
                } else {
                    //update existing raise
                    quote.jobQuoteItems.splice(existIndex, 1, wwRaise);
                }
            }
            let resetWWItem = this.resetWalkWayItem();

            this.setState({ quoteDetails: quote, walkWayItem: resetWWItem, showWalkwayPitch: false, walkwayStatusId: 0, walkwayIndexId: -1 });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }
    //END WALKWAY

    //FENCE BRACING
    openFenceBracing = (e: any, itemIndex: number) => {
        e.preventDefault();

        var quote = this.state.quoteDetails;
        var quoteItems = quote.jobQuoteItems;
        var quoteItem = quoteItems[itemIndex];
        var itemStatusId = quoteItem.statusId;

        this.setState({ showFenceBracing: true, calculatorIndex: itemIndex, calculatorStatusId: itemStatusId });
    }

    hideFenceBracing = () => {
        this.setState({ showFenceBracing: false, calculatorIndex: -1, calculatorStatusId: 0 });
    }

    saveFenceBracing = (fenceQuantity: number, braceQuantity: number, fenceBraceId: number, fenceNote: string, fenceAreaNote: string) => {
        var quote = this.state.quoteDetails;
        var quoteItems = quote.jobQuoteItems;
        var quoteItem = quoteItems[this.state.calculatorIndex];

        //editing the brace item so update based on items selected
        if (quoteItem.typeId === 51) {
            quoteItem.quantity = braceQuantity;
            quoteItem.fenceBraceId = fenceBraceId;
            quoteItem.notes += fenceNote;
            this.setState({ showFenceBracing: false, fenceArea: fenceAreaNote, calculatorIndex: -1, calculatorStatusId: 0, saveDisabled: false });

            //calculate the price for the braces
            this.calcQuotePrice(quote, quoteItem);
        } else {
            //editing fencing
            quoteItem.quantity = fenceQuantity;
            quoteItem.notes += fenceNote;
            this.calcFencePrice(quote, quoteItem, braceQuantity, fenceBraceId, fenceNote, fenceAreaNote);
        }
    }

    calcFencePrice = async (quote: JobQuoteDetails, quoteItem: JobQuoteItems, braceQuantity: number, fenceBraceId: number, fenceNote: string, fenceAreaNote: string) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //calculate totals
        var itemOption = _.find(this.state.itemOptions, { 'id': quoteItem.itemId * 1 });
        var chargeGst = itemOption?.chargeGst;

        var chargeTravel = false;
        let hirePeriod = quoteItem.customHirePeriod && quoteItem.invoicePeriodTypeId === 1 ? quoteItem.hirePeriod * 7 : quoteItem.hirePeriod;

        axios.get('api/Job/CalculateQuotePrice?SubId=' + user.sub + '&UseCustomPriceList=' + this.state.useCustomPriceList + '&JobId=' + this.props.jobId +
            '&CustomerId=' + this.props.customerId + "&ItemId=" + quoteItem.itemId + "&JobItemTypeId=" + quoteItem.typeId + "&ProductGroupId=" + quoteItem.productGroupId + "&HirePeriod=" + hirePeriod + "&UsePerMetrePricing=false" +
            "&FrequencyId=" + quoteItem.frequencyId + "&LocationId=" + quoteItem.locationId + "&Size=" + quoteItem.size + "&Quantity=" + quoteItem.quantity + "&ExtraHours=" + quoteItem.extraHours +
            "&ChargeGst=" + chargeGst + "&ExtraItemId=" + quoteItem.extras.itemId + "&ExtraItemQuantity=" + quoteItem.extras.quantity +
            "&IncludeTrolley=" + quoteItem.trolley + "&SiteAddressDuration=" + quote.siteAddressDuration + "&TruckId=" + quoteItem.truckId +
            "&IsEws=" + quoteItem.isEws + "&IsEvent=" + quoteItem.isEvent + "&ChargeTravel=" + chargeTravel + "&TotalSteps=0&IncludeStepsTravel=false&ChargeWeekendJob=false&ChargeEmergencyJob=false" +
            "&ChargeFuelSurcharge=" + this.state.chargeFuelSurcharge, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            quoteItem.initialHire = res.data.initialHire;
            quoteItem.travelAmount = res.data.travelAmount;
            quoteItem.cleaningFee = res.data.cleaningAmount;
            quoteItem.trenchFee = res.data.trenchFeeAmount;
            quoteItem.fuelSurchargeAmount = res.data.fuelSurchargeAmount;
            quoteItem.rate = res.data.rate;
            quoteItem.gst = res.data.gst;
            quoteItem.amount = res.data.amount;
            quoteItem.overhireRate = res.data.overhireRate;

            this.setState({ showFenceBracing: false, fenceArea: fenceAreaNote, calculatorIndex: -1, calculatorStatusId: 0, saveDisabled: false });

            //create a new brace item
            var newIndex = quote.jobQuoteItems.length;
            if (braceQuantity > 0) {
                this.createBraceItem(quote, newIndex, fenceBraceId, braceQuantity, fenceNote);
            }

        })
        .catch(error => {
            this.setState({ showFenceBracing: false, calculatorIndex: -1, calculatorStatusId: 0, saveDisabled: false });
            toast.error(error.message);
        });
    }


    createBraceItem = (quote: JobQuoteDetails, itemIndex: number, fenceBraceId: number, braceQty: number, braceNotes: string) => {
        var itemDetails = this.state.itemOptions.find(i => i.id === 145);
        if (itemDetails) {
            var newBraceItem: JobQuoteItems = {
                itemIndex: itemIndex - 1,
                id: 0,
                itemId: itemDetails.id,
                item: "Fencing Braces",
                itemDescription: "",
                installOnly: false,
                extendable: true,
                invoiceDescription: "",
                typeId: 51,
                productGroupId: itemDetails.productGroupId,
                steepRoofPitch: 0,
                isVoid: false,
                isTower: false,
                isWalkWay: false,
                unitOfMeasure: "each",
                status: "Quoted",
                statusId: 1,
                hirePeriod: itemDetails.priceListDefaultDays,
                defaultHirePeriod: itemDetails.priceListDefaultDays,
                customHirePeriod: false,
                hirePeriodWeeksDesc: "",
                frequencyId: -1,
                locationId: -1,
                fenceBraceId: fenceBraceId,
                size: 0,
                includeInstallDismantle: 0,
                quantity: braceQty,
                initialHire: 0,
                travelAmount: 0,
                cleaningFee: 0,
                trenchFee: 0,
                confinedSpaceAmount: 0,
                sampleTestingAmount: 0,
                wasteDisposalAmount: 0,
                fuelSurchargeAmount: 0,
                extraHours: 0,
                kwikstageInstalledForId: -1,
                rate: 0,
                gst: 0,
                amount: 0,
                overhireRate: 0,
                estCostPriceFormatted: "$0.00",
                estMarginFormatted: "$0.00",
                estMarginPercentageFormatted: "0%",
                callout: false,
                notes: braceNotes,
                quoteNote: "",
                linkedId: 0,
                canEditTravel: true,
                itemOrder: itemIndex,
                showOnQuote: true,
                isEws: false,
                isEvent: false,
                truckId: -1,
                truckDoorsId: -1,
                trolley: false,
                extras: {
                    itemId: -1,
                    quantity: 0,
                    equipped: false
                },
                incStepsTravel: false,
                invoicePeriodTypeId: 2,
                tankLidExposed: false,
                weekendJob: false,
                emergencySameDayJob: false,
                epaQuestionsAnswered: false,
                isDirty: false
            };
            quote.jobQuoteItems.splice(itemIndex - 1, 0, newBraceItem);

            //update item indexs
            for (var i = 0; i < quote.jobQuoteItems.length; i++) {
                quote.jobQuoteItems[i].itemIndex = i;
            }

            //calculate the price for the braces
            this.calcQuotePrice(quote, newBraceItem);
        }
    }
    //END FENCE BRACING

    onCellCheckboxChange = (e: any, itemIndex: number) => {
        var quote = this.state.quoteDetails;
        var quoteItems = quote.jobQuoteItems;
        var quoteItem = quoteItems[itemIndex];
        quoteItem.showOnQuote = e.target.checked;
        this.setState({ quoteDetails: quote, saveDisabled: false });
        this.saveShowOnQuote(quoteItem.id, e.target.checked);
    }

    //Enter custom hire period
    editCustomHirePeriod = (e: any, itemIndex: number) => {
        e.preventDefault();

        var quote = this.state.quoteDetails;
        var quoteItems = quote.jobQuoteItems;
        var item = quoteItems[itemIndex];
        item.customHirePeriod = true;
        item.hirePeriod = item.hirePeriod <= 0 ? 1 : item.invoicePeriodTypeId === 1 ? item.hirePeriod / 7 : item.hirePeriod;
        this.setState({ quoteDetails: quote, saveDisabled: false });
    }
    //END Custom Hire Period

    async saveShowOnQuote(quoteItemId: number, showOnQuote: boolean) {
        const token = await authService.getAccessToken();

        var saveShowOnQuote = {
            jobQuoteItemId: quoteItemId,
            showOnQuote: showOnQuote
        };

        axios.post('api/Job/SaveQuoteShowOnQuote', saveShowOnQuote, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    onCellPriceItemChange = (e: any, lastrow: boolean, itemIndex: number) => {
        var quote = this.state.quoteDetails;
        var quoteItems = quote.jobQuoteItems;
        var quoteItem = quoteItems[itemIndex];

        var value = e.target.value * 1;

        let newQuoteItem: any = {};
        newQuoteItem = quoteItem;
        newQuoteItem[e.target.name] = value;
        newQuoteItem.isDirty = true;

        //calculate amount field
        var itemAmount = quoteItem.initialHire + quoteItem.travelAmount + quoteItem.cleaningFee + quoteItem.trenchFee + quoteItem.confinedSpaceAmount + quoteItem.sampleTestingAmount + quoteItem.wasteDisposalAmount + quoteItem.fuelSurchargeAmount;
        quoteItem.amount = parseFloat(itemAmount.toFixed(2));
        //calculate rate & gst
        var rateGst = this.calculateRateGst(newQuoteItem.itemId, itemAmount);
        newQuoteItem.rate = rateGst.rate;
        newQuoteItem.gst = rateGst.gst;

        var total = this.calculateTotal(quoteItems);
        quote.totalQuotedAmount = parseFloat(total.toFixed(2));
        quote.totalQuotedAmountFormatted = total.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });
        quote.totalInvoiceAmount = (total * 1) + (quote.totalInvoiceExtraAmount * 1);
        quote.totalInvoiceAmountFormatted = quote.totalInvoiceAmount.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });

        //check if this row is the last row, and if there is a value set and if so add a new blank row
        if (lastrow && (this.props.jobTypeId === 1 || this.props.jobTypeId === 3)) {
            let filteredItems = this.state.quoteDetails.jobQuoteItems.filter(data =>
                data.status != "Cancelled"
            );
            var blankLine = this.addBlankLine(quoteItems.length, filteredItems.length);
            quote.jobQuoteItems.push(blankLine);
        }

        this.setState({ quoteDetails: quote, saveDisabled: false });
    }

    onHireCellChange = (lastrow: boolean, itemIndex: number, e: any) => {
        var quote = this.state.quoteDetails;
        var quoteItems = quote.jobQuoteItems;
        var quoteItem = quoteItems[itemIndex];

        let newQuoteItem: any = {};
        newQuoteItem = quoteItem;
        newQuoteItem[e.target.name] = e.target.value * 1;
        newQuoteItem.isDirty = true;

        //check if this row is the last row, and if there is a value set and if so add a new blank row
        if (lastrow && (this.props.jobTypeId === 1 || this.props.jobTypeId === 3)) {
            let filteredItems = this.state.quoteDetails.jobQuoteItems.filter(data =>
                data.status != "Cancelled"
            );
            var blankLine = this.addBlankLine(quoteItems.length, filteredItems.length);
            quote.jobQuoteItems.push(blankLine);
        }

        this.calcQuotePrice(quote, quoteItem);  //this will update the state once it's calculated the new price
    }

    bracingChange = (lastrow: boolean, itemIndex: number, value: number) => {
        var quote = this.state.quoteDetails;
        var quoteItems = quote.jobQuoteItems;
        var quoteItem = quoteItems[itemIndex];
        quoteItem.isDirty = true;
        quoteItem.fenceBraceId = value;

        //calculate the qty if we are bracing every panel / 2nd panel / 3rd panel
        if (value === 1 || value === 2 || value === 3) {
            //find the fencing item so we can get total fence metres
            var fenceItem = quoteItems.find(i => i.typeId === 50);
            if (fenceItem) {
                let fenceQty = fenceItem.quantity;
                var braceQty = fenceQty / 2.4 / value;
                braceQty = Math.trunc(braceQty);
                quoteItem.quantity = braceQty;
            }
        }

        //check if this row is the last row, and if there is a value set and if so add a new blank row
        if (lastrow && (this.props.jobTypeId === 1 || this.props.jobTypeId === 3)) {
            let filteredItems = this.state.quoteDetails.jobQuoteItems.filter(data =>
                data.status != "Cancelled"
            );
            var blankLine = this.addBlankLine(quoteItems.length, filteredItems.length);
            quote.jobQuoteItems.push(blankLine);
        }

        this.calcQuotePrice(quote, quoteItem);
    }

    onCellHoursChange = (e: any, lastrow: boolean, itemIndex: number) => {
        var quote = this.state.quoteDetails;
        var quoteItems = quote.jobQuoteItems;
        var quoteItem = quoteItems[itemIndex];
        var value = e.target.value * 1;

        let newQuoteItem: any = {};
        newQuoteItem = quoteItem;
        newQuoteItem[e.target.name] = value;
        newQuoteItem.isDirty = true;

        //check if this row is the last row, and if there is a value set and if so add a new blank row
        if (lastrow && (this.props.jobTypeId === 1 || this.props.jobTypeId === 3)) {
            let filteredItems = this.state.quoteDetails.jobQuoteItems.filter(data =>
                data.status != "Cancelled"
            );
            var blankLine = this.addBlankLine(quoteItems.length, filteredItems.length);
            quote.jobQuoteItems.push(blankLine);
        }

        if (quoteItem.typeId === 61) {
            newQuoteItem.trenchFee = value * this.state.epaTruckHireRate;
            this.calcEpaQuotePrice(quote, quoteItem);
        } else {
            this.calcQuotePrice(quote, quoteItem);
        }
    }

    onCellItemChange = (e: any, lastrow: boolean, itemIndex: number) => {
        var quote = this.state.quoteDetails;
        var quoteItems = quote.jobQuoteItems;
        var quoteItem = quoteItems[itemIndex];
        let newQuoteItem: any = {};
        newQuoteItem = quoteItem;
        newQuoteItem.isDirty = true;
        let value = e.target.value * 1;
        newQuoteItem[e.target.name] = value;

        //if updating itemId then need to update defaults
        quoteItem.customHirePeriod = false;
        quoteItem.size = 0;
        quoteItem.extraHours = 0;
        quoteItem.initialHire = 0;
        quoteItem.travelAmount = 0;
        quoteItem.cleaningFee = 0;
        quoteItem.trenchFee = 0;
        quoteItem.confinedSpaceAmount = 0;
        quoteItem.sampleTestingAmount = 0;
        quoteItem.wasteDisposalAmount = 0;
        quoteItem.fuelSurchargeAmount = 0;
        quoteItem.amount = 0;
        quoteItem.overhireRate = 0;
        quoteItem.fenceBraceId = -1;
        var itemRow = _.find(this.state.itemOptions, { 'id': value });
        if (itemRow) {
            newQuoteItem["item"] = itemRow.name;
            if (itemRow.name.toLowerCase().includes("void")) {
                newQuoteItem["isVoid"] = true;
            } else {
                newQuoteItem["isVoid"] = false;
            }
            if (itemRow.name.toLowerCase().includes("tower")) {
                newQuoteItem["isTower"] = true;
                newQuoteItem["includeInstallDismantle"] = 1;
            } else {
                newQuoteItem["isTower"] = false;
                newQuoteItem["includeInstallDismantle"] = 0;
            }
            newQuoteItem["installOnly"] = itemRow.installOnly;
            newQuoteItem["extendable"] = itemRow.extendable;
            newQuoteItem["typeId"] = itemRow.typeId;
            newQuoteItem["unitOfMeasure"] = itemRow.unitOfMeasure;
            newQuoteItem["callout"] = itemRow.callout;
            newQuoteItem["hirePeriod"] = itemRow.priceListDefaultDays;
            newQuoteItem["defaultHirePeriod"] = itemRow.priceListDefaultDays;
            newQuoteItem["isWalkWay"] = itemRow.isWalkWay;
            newQuoteItem["isEws"] = itemRow.isEws;
            newQuoteItem["isEvent"] = itemRow.isEvent;
            newQuoteItem["truckId"] = itemRow.defaultTruckId;
            newQuoteItem["itemDescription"] = itemRow.description;
            newQuoteItem["invoicePeriodTypeId"] = itemRow.invoicePeriodTypeId;
            newQuoteItem["canEditTravel"] = true; //(itemRow.priceListItem && quote.siteAddressDuration > 0) || itemRow.id == 4 || itemRow.id == 25 || itemRow.id == 33 ? false : true;
            newQuoteItem["productGroupId"] = itemRow.productGroupId;

            //equipment is included in lunchroom pricing
            if (itemRow.typeId === 17) {
                quoteItem.extras.equipped = true;
            } else {
                quoteItem.extras.equipped = false;
            }

            if (itemRow.typeId === 29) {
                //showers automatically get a trolley added
                quoteItem.trolley = true;
            } else {
                quoteItem.trolley = false;
            }

            //make sure the extras are updated per item type
            if (itemRow.typeId === 14 && quoteItem.extras.quantity > 0) {
                quoteItem.extras.itemId = this.state.siteOfficeExtraId;
            } else if (itemRow.typeId === 17 && quoteItem.extras.quantity > 0) {
                quoteItem.extras.itemId = this.state.lunchRoomExtraId;
            } else if (itemRow.typeId != 27) {
                //lunchrooms and crossovers have extras
                //clear any extras as item id has changed to an item with no extras
                quoteItem.extras.itemId = -1;
                quoteItem.extras.quantity = 0;
            }

            if (this.props.systemCompanyId === 2 || itemRow.typeId === 8 || (itemRow.typeId >= 50 && itemRow.typeId <= 54)) {
                //Scaffold needs to be 0 as well
                //reset fencing items to 0 for qty
                quoteItem.quantity = 0;
            } else {
                quoteItem.quantity = 1;
            }

            if (itemRow.typeId === 58) {
                quoteItem.size = itemRow.name.includes("Treatment Plant") ? 7000 : 3200;
            } else if (itemRow.typeId === 59) {
                quoteItem.size = 1000;
            } else if (itemRow.typeId === 60) {
                quoteItem.size = 4000;
            }

            if (itemRow.typeId === 55) {
                let stepsItems = quoteItems.filter(i => i.typeId === 55 && i.status != "Cancelled");

                if (stepsItems.length === 1) {
                    //need to check if this is our first steps row and if so set inc steps travel to true
                    quoteItem.incStepsTravel = true;
                } else {
                    quoteItem.incStepsTravel = false;
                }
            } else {
                quoteItem.incStepsTravel = false;
            }

            if (itemRow.typeId === 61) {
                //default truck hours to 3 and calculate truck hire
                quoteItem.extraHours = 3;
                quoteItem.trenchFee = 3 * this.state.epaTruckHireRate;
            }
        }

        this.calculateQuotePrices(lastrow, itemIndex, "itemId", value, quote, quoteItems, newQuoteItem);
    }

    onCellChange = (lastrow: boolean, itemIndex: number, item: string, value: number) => {
        var quote = this.state.quoteDetails;
        var quoteItems = quote.jobQuoteItems;
        var quoteItem = quoteItems[itemIndex];
        let newQuoteItem: any = {};
        newQuoteItem = quoteItem;
        newQuoteItem.isDirty = true;
        newQuoteItem[item] = value;

        this.calculateQuotePrices(lastrow, itemIndex, item, value, quote, quoteItems, newQuoteItem);
    }

    calculateQuotePrices = (lastrow: boolean, itemIndex: number, item: string, value: number, quote: JobQuoteDetails, quoteItems: JobQuoteItems[], quoteItem: JobQuoteItems) => {
        //check if this row is the last row, and if there is a value set and if so add a new blank row
        if (lastrow && (this.props.jobTypeId === 1 || this.props.jobTypeId === 3)) {
            let filteredItems = this.state.quoteDetails.jobQuoteItems.filter(data =>
                data.status != "Cancelled"
            );
            var blankLine = this.addBlankLine(quoteItems.length, filteredItems.length);
            quote.jobQuoteItems.push(blankLine);
        }

        //run different calculations depending on the item selected
        if (quoteItem.typeId === 61 && quoteItem.quantity > 0 && quoteItem.hirePeriod > 0) {
            this.calculateEpaPrice(quote, quoteItem);
        } else if (quoteItem.isWalkWay && quoteItem.quantity > 0 && quoteItem.hirePeriod > 0) {
            this.calcWalkWayForRaise(itemIndex, quote, quoteItems, quoteItem);
        } else if (quoteItem.isTower && quoteItem.size > 0 && quoteItem.quantity > 0 && quoteItem.hirePeriod > 0) {
            this.calcTower(itemIndex, quote, quoteItem);
        } else if (item === "hirePeriod" && quoteItem.itemId === 4) {
            this.calcKwikstageExtend(quote, quoteItem, value);
        } else if ((item === "hirePeriod" || item === "quantity") && (quoteItem.itemId === 25 || quoteItem.itemId === 33)) {
            this.setState({ quoteDetails: quote });
        } else if (quoteItem.quantity > 0 && quoteItem.hirePeriod > 0) {
            this.calcQuotePrice(quote, quoteItem);
        } else {
            this.setState({ quoteDetails: quote });
        } 
    }

    calculateEpaPrice(quote: JobQuoteDetails, quoteItem: JobQuoteItems) {
        var amount = quoteItem.initialHire + quoteItem.travelAmount + quoteItem.cleaningFee + quoteItem.trenchFee + quoteItem.confinedSpaceAmount + quoteItem.sampleTestingAmount + quoteItem.wasteDisposalAmount + quoteItem.fuelSurchargeAmount;
        quoteItem.amount = parseFloat(amount.toFixed(2));;

        var total = this.calculateTotal(quote.jobQuoteItems);
        quote.totalQuotedAmount = total;
        quote.totalQuotedAmountFormatted = total.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });
        quote.totalInvoiceAmount = (total * 1) + (quote.totalInvoiceExtraAmount * 1);
        quote.totalInvoiceAmountFormatted = quote.totalInvoiceAmount.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });

        this.setState({ quoteDetails: quote, saveDisabled: false });
    }

    async calcWalkWayForRaise(itemIndex: number, quote: JobQuoteDetails, quoteItems: JobQuoteItems[], quoteItem: JobQuoteItems) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var itemOption = _.find(this.state.itemOptions, { 'id': quoteItem.itemId * 1 });
        var chargeGst = itemOption?.chargeGst;

        var wwItem = {
            jobId: this.props.jobId,
            customerId: this.props.customerId,
            useCustomPriceList: this.state.useCustomPriceList,
            chargeGst: chargeGst,
            walkWayItem: quoteItem,
            quoteNo: quote.quoteNo,
            quoteNotes: quote.quoteNotes,
            manualQuoteNumber: quote.manualQuoteNumber,
            requireSiteVisit: quote.requireSiteVisit,
            siteVisitPerson: quote.siteVisitPerson,
            chargeFuelSurcharge: this.state.chargeFuelSurcharge,
            subId: user.sub
        };

        axios.post('api/Job/CalculateWalkWayQuotePrice', wwItem, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            let newquoteItem = res.data.walkWayItem;
            newquoteItem.itemIndex = itemIndex;
            quoteItems.splice(itemIndex, 1, newquoteItem);

            var wwRaise = res.data.walkWayRaiseItem;
            if (wwRaise) {
                //check if wwRaise already exists and just needs updating
                var existIndex = quote.jobQuoteItems.findIndex(jqi => jqi.id === wwRaise.id);
                if (existIndex < 0) {
                    //add new raise
                    //insert the raise before the blank new row
                    var indexToInsert = quote.jobQuoteItems.length - 1;
                    wwRaise.itemIndex = indexToInsert;
                    indexToInsert = indexToInsert < 0 ? 0 : indexToInsert;
                    quote.jobQuoteItems.splice(indexToInsert, 0, wwRaise);

                    //update blank new row with next itemindex
                    var blankRowIndex = quote.jobQuoteItems.length - 1;
                    var blankRow = quote.jobQuoteItems[blankRowIndex];
                    if (blankRow) {
                        blankRow.itemIndex = (indexToInsert + 1);
                    }
                } else {
                    //update existing raise
                    quote.jobQuoteItems.splice(existIndex, 1, wwRaise);
                }
            }
            this.setState({ quoteDetails: quote, saveDisabled: false });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    calcTower = async (itemIndex: number, quote: JobQuoteDetails, quoteItem: JobQuoteItems) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var itemOption = _.find(this.state.itemOptions, { 'id': quoteItem.itemId * 1 });
        var chargeGst = itemOption?.chargeGst;
        let incInsDis = quoteItem.includeInstallDismantle === 1;

        axios.get('api/Job/CalculateTowerQuotePrice?JobId=' + this.props.jobId + '&ItemId=' + quoteItem.itemId + '&chargeGst=' + chargeGst + '&Size=' + quoteItem.size + '&ChargeInstall=' + incInsDis + '&Quantity=' + quoteItem.quantity + '&HirePeriod=' + quoteItem.hirePeriod + '&ChargeFuelSurcharge=' + this.state.chargeFuelSurcharge, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            quoteItem.travelAmount = res.data.travelAmount;
            quoteItem.fuelSurchargeAmount = res.data.fuelSurchargeAmount;
            quoteItem.rate = res.data.rate;
            quoteItem.gst = res.data.gst;
            quoteItem.amount = res.data.amount;
            quoteItem.initialHire = res.data.initialHire;
            quoteItem.overhireRate = res.data.overhireRate;

            var total = this.calculateTotal(quote.jobQuoteItems);
            quote.totalQuotedAmount = total;
            quote.totalQuotedAmountFormatted = total.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });
            quote.totalInvoiceAmount = (total * 1) + (quote.totalInvoiceExtraAmount * 1);
            quote.totalInvoiceAmountFormatted = quote.totalInvoiceAmount.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });


            this.setState({ quoteDetails: quote, saveDisabled: false });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    async calcKwikstageExtend(quote: JobQuoteDetails, quoteItem: JobQuoteItems, hirePeriod: number) {
        const token = await authService.getAccessToken();

        //recalculate kwikstage
        axios.get('api/Job/GetKwikstageExtendQuotePrice?JobId=' + this.props.jobId + '&JobQuoteItemId=' + quoteItem.id + '&HirePeriod=' + hirePeriod, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            var ksItem = res.data.kwikstageItemPrice;
            quoteItem.amount = ksItem.amount;
            quoteItem.rate = ksItem.rate;
            quoteItem.gst = ksItem.gst;

            var total = this.calculateTotal(quote.jobQuoteItems);
            quote.totalQuotedAmount = total;
            quote.totalQuotedAmountFormatted = total.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });
            quote.totalInvoiceAmount = (total * 1) + (quote.totalInvoiceExtraAmount * 1);
            quote.totalInvoiceAmountFormatted = quote.totalInvoiceAmount.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });

            this.setState({ quoteDetails: quote, saveDisabled: false });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    async calcQuotePrice(quote: JobQuoteDetails, quoteItem: JobQuoteItems) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //calculate totals
        var itemOption = _.find(this.state.itemOptions, { 'id': quoteItem.itemId * 1 });
        var chargeGst = itemOption?.chargeGst;

        var chargeTravel = quote.customerPickingUp < 1;       //default to true unless customer picking up is set to 1
        if (quoteItem.typeId === 27 || quoteItem.typeId === 28 || quoteItem.typeId === 40) {
            //crossovers and rubbish cages don't have a travel charge if their is a toilet being hired
            var hiringToilet = quote.jobQuoteItems.filter(i => (i.typeId === 25 || i.typeId === 33) && i.statusId != 8).length > 0;
            if (hiringToilet) {
                //toilet is being hired
                chargeTravel = false;
            }
        }

        let hirePeriod = quoteItem.customHirePeriod && quoteItem.invoicePeriodTypeId === 1 ? quoteItem.hirePeriod * 7 : quoteItem.hirePeriod;
        let totalSteps = 0;
        let stepItems = quote.jobQuoteItems.filter(i => i.typeId === 55 && i.status != "Cancelled");
        if (quoteItem.typeId === 55) {
            //need to sum up all the steps quantity to calculate the travel
            for (var i = 0; i < stepItems.length; i++) {
                totalSteps += stepItems[i].quantity;
            }
        }

        axios.get('api/Job/CalculateQuotePrice?SubId=' + user.sub + '&UseCustomPriceList=' + this.state.useCustomPriceList + '&JobId=' + this.props.jobId +
            '&CustomerId=' + this.props.customerId + "&ItemId=" + quoteItem.itemId + "&JobItemTypeId=" + quoteItem.typeId + "&ProductGroupId=" + quoteItem.productGroupId + "&HirePeriod=" + hirePeriod + "&UsePerMetrePricing=false" +
            "&FrequencyId=" + quoteItem.frequencyId + "&LocationId=" + quoteItem.locationId + "&Size=" + quoteItem.size + "&Quantity=" + quoteItem.quantity + "&ExtraHours=" + quoteItem.extraHours +
            "&ChargeGst=" + chargeGst + "&ExtraItemId=" + quoteItem.extras.itemId + "&ExtraItemQuantity=" + quoteItem.extras.quantity +
            "&IncludeTrolley=" + quoteItem.trolley + "&SiteAddressDuration=" + quote.siteAddressDuration + "&TruckId=" + quoteItem.truckId +
            "&IsEws=" + quoteItem.isEws + "&IsEvent=" + quoteItem.isEvent + "&ChargeTravel=" + chargeTravel + "&TotalSteps=" + totalSteps + "&IncludeStepsTravel=" + quoteItem.incStepsTravel +
            "&ChargeWeekendJob=" + quoteItem.weekendJob + "&ChargeEmergencyJob=" + quoteItem.emergencySameDayJob + "&ChargeFuelSurcharge=" + this.state.chargeFuelSurcharge, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            quoteItem.initialHire = res.data.initialHire;
            quoteItem.travelAmount = res.data.travelAmount;
            quoteItem.cleaningFee = res.data.cleaningAmount;
            quoteItem.trenchFee = res.data.trenchFeeAmount;
            quoteItem.fuelSurchargeAmount = res.data.fuelSurchargeAmount;
            quoteItem.rate = res.data.rate;
            quoteItem.gst = res.data.gst;
            quoteItem.amount = res.data.amount;
            quoteItem.overhireRate = res.data.overhireRate;

            if (quoteItem.typeId === 55 && !quoteItem.incStepsTravel) {
                //for steps we store the travel amount against the first steps item
                var stepItem = stepItems.find(si => si.incStepsTravel);
                if (stepItem)
                {
                    stepItem.travelAmount = res.data.stepsTravelAmount;
                    stepItem.amount = stepItem.initialHire + stepItem.travelAmount;
                }
            }

            var total = this.calculateTotal(quote.jobQuoteItems);
            quote.totalQuotedAmount = total;
            quote.totalQuotedAmountFormatted = total.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });
            quote.totalInvoiceAmount = (total * 1) + (quote.totalInvoiceExtraAmount * 1);
            quote.totalInvoiceAmountFormatted = quote.totalInvoiceAmount.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });

            this.setState({ quoteDetails: quote, saveDisabled: false });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    async calcEpaQuotePrice(quote: JobQuoteDetails, quoteItem: JobQuoteItems) {
        var amount = quoteItem.initialHire + quoteItem.trenchFee + quoteItem.confinedSpaceAmount + quoteItem.sampleTestingAmount + quoteItem.wasteDisposalAmount + quoteItem.travelAmount + quoteItem.cleaningFee + quoteItem.fuelSurchargeAmount;
        quoteItem.amount = parseFloat(amount.toFixed(2));;

        var total = this.calculateTotal(quote.jobQuoteItems);
        quote.totalQuotedAmount = total;
        quote.totalQuotedAmountFormatted = total.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });
        quote.totalInvoiceAmount = (total * 1) + (quote.totalInvoiceExtraAmount * 1);
        quote.totalInvoiceAmountFormatted = quote.totalInvoiceAmount.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });

        this.setState({ quoteDetails: quote, saveDisabled: false });
    }

    calculateTotal = (quoteItems: JobQuoteItems[]) => {
        var quoteTotal = 0;
        for (var i = 0; i < quoteItems.length - 1; i++) {
            if (quoteItems[i].statusId != 8) {
                //only include non cancelled items
                quoteTotal += (quoteItems[i].amount * 1);
                
            }
        }
        
        return quoteTotal;
    }

    onCellChangeNumber = (lastrow: boolean, itemIndex: number, item: string, value: any) => {
        var quote = this.state.quoteDetails;
        var quoteItem = this.state.quoteDetails.jobQuoteItems[itemIndex];
        let newQuoteItem: any = {};
        newQuoteItem = quoteItem;
        newQuoteItem[item] = value * 1;

        if (item == "amount") {
            //calc rate and gst
            var amount = value * 1;
            var rateGst = this.calculateRateGst(newQuoteItem.itemId, amount);
            newQuoteItem.rate = rateGst.rate;
            newQuoteItem.gst = rateGst.gst;

            //recalc total
            var totalQuotedAmount = this.calculateTotal(quote.jobQuoteItems);
            quote.totalQuotedAmount = totalQuotedAmount;
            quote.totalQuotedAmountFormatted = totalQuotedAmount.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });
            quote.totalInvoiceAmount = (totalQuotedAmount * 1) + (quote.totalInvoiceExtraAmount * 1);
            quote.totalInvoiceAmountFormatted = quote.totalInvoiceAmount.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });
        }

        //check if this row is the last row, and if there is a value set and if so add a new blank row
        if (lastrow && (this.props.jobTypeId === 1 || this.props.jobTypeId === 3)) {
            let filteredItems = this.state.quoteDetails.jobQuoteItems.filter(data =>
                data.status != "Cancelled"
            );
            var blankLine = this.addBlankLine(quote.jobQuoteItems.length, filteredItems.length);
            quote.jobQuoteItems.push(blankLine);
        }

        this.setState({ quoteDetails: quote, saveDisabled: false });
    }

    calculateRateGst = (itemId: number, amount: number) => {
        var itemRow = _.find(this.state.itemOptions, { 'id': itemId });
        var chargeGst = true;
        if (itemRow) {
            chargeGst = itemRow.chargeGst;
        }

        if (chargeGst) {
            //calculate rate and GST
            var gstToCalc = this.state.gst + 1;
            var rate = amount / gstToCalc;
            var gstAmount = amount - rate;
            var rateGst: RateGst = {
                rate: rate,
                gst: gstAmount
            };
            return rateGst;
        }

        var rateGst: RateGst = {
            rate: amount,
            gst: 0
        };
        return rateGst;
    }

    //Cancel Popup
    cancelItem = (e: any, itemIndex: number) => {
        e.preventDefault();

        var quote = this.state.quoteDetails;
        var noItemsMin = this.props.jobTypeId === 1 || this.props.jobTypeId === 3 ? 1 : 0;
        if (quote.jobQuoteItems.length > noItemsMin) {
            this.getCancelReasons(itemIndex);
        } else {
            //can't delete only line
            toast.error("Cannot delete new row");
        }
    }

    async getCancelReasons(itemIndex: number) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();
        var quote = this.state.quoteDetails;
        var itemId = quote.jobQuoteItems[itemIndex].itemId;

        //look up item in item list
        var itemOptionsIndex = this.state.itemOptions.findIndex(items => items.id === itemId);
        var item = this.state.itemOptions[itemOptionsIndex].name;

        //get the list of cancel reasons
        axios.get("api/Job/GetCancelReasons?SubId=" + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            //show popup to cancel
            this.setState({ showCancelModal: true, cancelItem: item, cancelItemIndexId: itemIndex, cancelReasonId: -1, cancelOptions: res.data });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    hideCancelModal = () => {
        this.setState({ showCancelModal: false, cancelItem: "", cancelItemIndexId: -1, cancelReasonId: -1, saveDisabled: false });
    }

    handleCancelReasonChange = (e: any) => {
        let errors: any = {};

        if (e.target.value < 0) {
            errors["cancelReason"] = "Valid Cancel Reason Required";
            this.setState({ errors: errors });
        } else {
            this.setState({ cancelReasonId: e.target.value, errors: {} });
        }
    }

    validateCancel = () => {
        let errors: any = {};

        if (this.state.cancelReasonId < 0) {
            errors["cancelReason"] = "Cancel Reason is required";
            this.setState({ errors: errors });
            return false;
        } else {
            return true;
        }
    }

    saveCancel = () => {
        if (this.validateCancel()) {
            this.saveCancelQuote();
        }
    }

    async saveCancelQuote() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //cancel the item 
        var quote = this.state.quoteDetails;
        var quoteItems = quote.jobQuoteItems;
        var quoteItem = quoteItems[this.state.cancelItemIndexId];
        if (quoteItem) {
            quoteItem.status = "Cancelled";
            quoteItem.statusId = 8;
            //make sure user hasn't cleared any fields before cancelling item
            quoteItem.hirePeriod = !quoteItem.hirePeriod ? 0 : quoteItem.hirePeriod;
            quoteItem.quantity = !quoteItem.quantity ? 0 : quoteItem.quantity;
            quoteItem.amount = !quoteItem.amount ? 0 : quoteItem.amount;
            quoteItem.overhireRate = !quoteItem.overhireRate ? 0 : quoteItem.overhireRate;
            if (quoteItem.id > 0) {
                //update database
                var cancelItem = {
                    jobQuoteItem: quoteItem,
                    jobId: this.state.quoteDetails.jobId,
                    cancelReasonId: this.state.cancelReasonId,
                    subId: user.sub
                };

                axios.post('api/Job/CancelQuoteItem', cancelItem, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    if (res.data == true) {
                        toast.success("Item Cancelled");

                        //recalc total
                        var totalQuotedAmount = this.calculateTotal(quote.jobQuoteItems);
                        quote.totalQuotedAmount = totalQuotedAmount;
                        quote.totalQuotedAmountFormatted = totalQuotedAmount.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });
                        quote.totalInvoiceAmount = (totalQuotedAmount * 1) + (quote.totalInvoiceExtraAmount * 1);
                        quote.totalInvoiceAmountFormatted = quote.totalInvoiceAmount.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });

                        let itemOrder = 1;
                        for (var i = 0; i < quoteItems.length; i++) {
                            if (quoteItems[i].status != "Cancelled") {
                                quoteItems[i].itemOrder = itemOrder;
                                itemOrder += 1;
                            }
                        }

                        if (quoteItem.typeId === 55) {
                            //deleting steps so may need to recalc travel if there are other steps items in the quote
                            this.checkStepTravel(quote, quoteItems);
                        } else {
                            this.setState({ quoteDetails: quote, saveDisabled: false, showCancelModal: false, cancelItem: "", cancelItemIndexId: -1, cancelReasonId: -1 });
                        } 
                    } else {
                        toast.error("There was an error cancelling the item, please refresh and try again!");
                    }
                })
                .catch(error => {
                    toast.error(error.message);
                });
            } else {
                let itemOrder = 1;
                for (var i = 0; i < quoteItems.length; i++) {
                    if (quoteItems[i].status != "Cancelled") {
                        quoteItems[i].itemOrder = itemOrder;
                        itemOrder += 1;
                    }
                }

                if (quoteItem.typeId === 55) {
                    this.checkStepTravel(quote, quoteItems);
                } else {
                    this.setState({ quoteDetails: quote, saveDisabled: false, showCancelModal: false, cancelItem: "", cancelItemIndexId: -1, cancelReasonId: -1 });
                } 
            }

        }

    }

    //steps may need the price re-calc if deleted
    checkStepTravel = (quote: JobQuoteDetails, quoteItems: JobQuoteItems[]) => {
        //deleting steps so may need to recalc travel if there are other steps items in the quote
        let stepItems = quoteItems.filter(i => i.typeId === 55 && i.status != "Cancelled");
        if (stepItems.length > 0) {
            let stepItem = stepItems.find(i => i.incStepsTravel);
            if (!stepItem) {
                stepItem = stepItems[0];
                stepItem.incStepsTravel = true;
            };

            this.setState({ saveDisabled: false, showCancelModal: false, cancelItem: "", cancelItemIndexId: -1, cancelReasonId: -1 });

            //need to re-calc the step item to include travel
            this.calcQuotePrice(quote, stepItem);
        } else {
            this.setState({ quoteDetails: quote, saveDisabled: false, showCancelModal: false, cancelItem: "", cancelItemIndexId: -1, cancelReasonId: -1 });
        }
    }
    //End Cancel Popup

    createQuote = () => {
        if (this.state.saveDisabled) {
            return;
        }
        this.setState({ saveDisabled: true });

        this.createNewQuote();
    }

    async createNewQuote() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var quote = {
            jobId: this.props.jobId,
            subId: user.sub
        };

        axios.post('api/Job/CreateQuote', quote, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Quote Saved");
            var blankLine = this.addBlankLine(0, 0);
            //then need to clear notes so can resave and add note to list
            var quoteDetails: JobQuoteDetails = {
                id: res.data.id,
                jobId: res.data.jobId,
                quoteNo: res.data.quoteNo,
                manualQuoteNumber: res.data.manualQuoteNumber,
                isEvent: res.data.isEvent,
                requireSiteVisit: res.data.requireSiteVisit,
                siteVisitPerson: -1,
                siteContactName: res.data.siteContactName,
                siteContactPhone: res.data.siteContactPhone,
                showSiteVisitNote: true,
                totalQuotedAmount: 0,
                totalQuotedAmountFormatted: "$0.00",
                totalInvoiceExtraAmount: 0,
                totalInvoiceExtraAmountFormatted: "$0.00",
                totalInvoiceAmount: 0,
                totalInvoiceAmountFormatted: "$0.00",
                jobQuoteItems: [blankLine],
                quoteNotes: res.data.quoteNotes,
                siteAddressDuration: res.data.siteAddressDuration,
                customerPickingUp: 0,
                isDirty: false
            };
            this.setState({ quoteDetails: quoteDetails, saveDisabled: false });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    //Quote Notes Popup 
    addQuoteNotes = (e: any, itemIndex: number) => {
        e.preventDefault();

        var quoteItems = this.state.quoteDetails.jobQuoteItems;
        var quoteItem = quoteItems[itemIndex];
        var quoteNote = quoteItem.quoteNote;

        this.setState({ showQuoteNote: true, quoteNoteIndex: itemIndex, quoteNote: quoteNote });
    }
    //End Quote Notes Popup

    //Calculate Kwikstage Popup 
    calculateKwikstage = (e: any, itemIndex: number) => {
        e.preventDefault();

        this.calcKwikstage(itemIndex);
    }

    async calcKwikstage(itemIndex: number) {
        const token = await authService.getAccessToken();

        var quoteItems = this.state.quoteDetails.jobQuoteItems;
        var quoteItem = quoteItems[itemIndex];

        //get any calculator items
        axios.get("api/Job/GetKwikstageCalculatorItems?JobQuoteItemId=" + quoteItem.id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            var items = res.data;
            var blankRow = this.addBlankCalculatorRow();
            items.push(blankRow);

            var kwikstageItem: KwikstageItem = {
                extraHours: quoteItem.extraHours,
                kwikstageInstalledFor: quoteItem.kwikstageInstalledForId,
                quoteNote: quoteItem.quoteNote
            };

            this.setState({ showCalculator: true, calculatorIndex: itemIndex, calculatorItems: items, calculatorKwikstageItem: kwikstageItem, calculatorStatusId: quoteItem.statusId });

        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    addBlankCalculatorRow = () => {
        var item: KwikstageCalculation = {
            id: 0,
            starterBayId: -1,
            liftId: -1,
            bays: 0,
            baysRemaining: 0
        };
        return item;
    }

    resetKwikstageItem = () => {
        var item: KwikstageItem = {
            extraHours: 0,
            kwikstageInstalledFor: -1,
            quoteNote: ""
        };

        return item;
    }

    hideCalculateKwikstage = () => {
        var kwikstageItem = this.resetKwikstageItem();
        this.setState({ showCalculator: false, calculatorIndex: -1, calculatorItems: [], calculatorKwikstageItem: kwikstageItem, calculatorStatusId: 0 });
    }

    updateCalculateKwikstage = (items: KwikstageCalculation[]) => {
        this.setState({ calculatorItems: items });
    }

    updateCalculatorKwikstageItem = (item: KwikstageItem) => {
        this.setState({ calculatorKwikstageItem: item });
    }

    saveCalculateKwikstage = () => {
        this.calculateKwikstagePrice();
    }

    async calculateKwikstagePrice() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var quote = this.state.quoteDetails;
        var quoteItems = quote.jobQuoteItems;
        var quoteItem = quoteItems[this.state.calculatorIndex];

        var calcKwikstageItem = this.state.calculatorKwikstageItem;
        var calulatorItems = this.state.calculatorItems;
        calulatorItems.pop();

        var calculateKwikstagePrice = {
            id: quoteItem.id,
            jobQuoteId: quote.quoteNo,
            jobId: quote.jobId,
            itemId: quoteItem.itemId,
            hirePeriod: quoteItem.hirePeriod,
            extraHours: calcKwikstageItem.extraHours,
            kwikstageInstalledForId: calcKwikstageItem.kwikstageInstalledFor,
            quoteNote: calcKwikstageItem.quoteNote,
            itemOrder: quoteItem.itemOrder,
            calculatorItems: calulatorItems,
            subId: user.sub
        }

        axios.post('api/Job/CalculateKwikstageQuotePrice', calculateKwikstagePrice, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            var newquoteItem = res.data.kwikstageItem;
            newquoteItem.itemIndex = this.state.calculatorIndex;
            quoteItems.splice(this.state.calculatorIndex, 1, newquoteItem);
            var kwikstageItem = this.resetKwikstageItem();
            var kwikstageAdjustmentItem = res.data.kwikstageAdjustmentItem;

            if (kwikstageAdjustmentItem) {
                var existItemIndex = quoteItems.findIndex(qi => qi.id === kwikstageAdjustmentItem.id);
                if (existItemIndex >= 0) {
                    quoteItems.splice(existItemIndex, 1, res.data.kwikstageAdjustmentItem);
                } else {
                    //add the adjustment after the kwikstage item
                    var indexToAdd = this.state.calculatorIndex + 1;
                    quoteItems.splice(indexToAdd, 0, res.data.kwikstageAdjustmentItem);
                }
            }

            //reset item index
            let itemOrder = 1;
            for (var i = 0; i < quoteItems.length; i++) {
                quoteItems[i].itemIndex = i;
                if (quoteItems[i].status != "Cancelled") {
                    quoteItems[i].itemOrder = itemOrder;
                    itemOrder += 1;
                }
            }

            var total = this.calculateTotal(quote.jobQuoteItems);
            quote.totalQuotedAmount = total;
            quote.totalQuotedAmountFormatted = total.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });
            quote.totalInvoiceAmount = (total * 1) + (quote.totalInvoiceExtraAmount * 1);
            quote.totalInvoiceAmountFormatted = quote.totalInvoiceAmount.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });

            this.setState({ quoteDetails: quote, saveDisabled: false, showCalculator: false, calculatorIndex: -1, calculatorItems: [], calculatorKwikstageItem: kwikstageItem, calculatorStatusId: 0 });

            toast.success("Kwikstage Item has been saved")
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    //end calculate kwikstage

    //Quote Site Notes Popup
    addSiteNotes = () => {
        if (this.state.quoteDetails.id === 0) {
            toast.error("You must save the quote before adding site notes!");
        } else {
            this.getSiteNotes();
        }
    }

    async getSiteNotes() {
        const token = await authService.getAccessToken();

        axios.get("api/Job/GetJobQuoteSiteNotes?JobQuoteId=" + this.state.quoteDetails.id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            //show popup to cancel
            this.setState({ showAddSiteNotes: true, siteNotes: res.data });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    hideSiteNotes = () => {
        this.setState({ showAddSiteNotes: false, siteNotes: [] });
    }

    updateSiteNotes = (updatedSiteNotes: GenericList[]) => {
        this.setState({ siteNotes: updatedSiteNotes });
    }

    //End Quote Site Notes Popup

    //Quote Note Popup
    editQuoteNote = (e: any, itemIndex: number) => {
        e.preventDefault();

        var quote = this.state.quoteDetails;
        if (quote.jobQuoteItems.length > 1) {
            var quoteItem = quote.jobQuoteItems[itemIndex];

            this.setState({ showQuoteNote: true, quoteNote: quoteItem.quoteNote, quoteNoteIndex: itemIndex });
        }
    }

    hideQuoteNote = () => {
        this.setState({ showQuoteNote: false, quoteNote: "", quoteNoteIndex: -1 });
    }

    updateQuoteNote = (note: string) => {
        this.setState({ quoteNote: note });
    }

    saveQuoteNote = () => {
        var note = this.state.quoteNote;

        if (this.state.quoteNoteIndex >= 0) {
            this.saveQuoteNotes(this.state.quoteNoteIndex, note, 1);
        } else {
            this.setState({ showQuoteNote: false, quoteNote: "", quoteNoteIndex: -1 });
        }
    }

    //End Quote Note Popup

    //Notes Popup 
    editNotes = (e: any, itemIndex: number) => {
        e.preventDefault();

        var quote = this.state.quoteDetails;
        if (quote.jobQuoteItems.length > 0) {
            var quoteItem = quote.jobQuoteItems[itemIndex];

            var editNotes: EditNotes = {
                heading: "",
                parentIndex: 0,
                rowIndex: itemIndex,
                id: quoteItem.id,
                itemId: quoteItem.itemId,
                item: quoteItem.item,
                notes: quoteItem.notes
            }

            this.setState({ editNotes: editNotes, showEditNotesModal: true });
        }
  
    }

    hideNotes = () => {
        var editNotes: EditNotes = {
            heading: "",
            parentIndex: 0,
            rowIndex: 0,
            id: 0,
            itemId: 0,
            item: "",
            notes: ""
        }

        this.setState({ editNotes: editNotes, showEditNotesModal: false });
    }

    updateNotes = (editNote: EditNotes) => {
        var editNotes = this.state.editNotes;
        editNotes.notes = editNote.notes;
        this.setState({
            editNotes: editNotes
        });
    }

    saveNotes = () => {
        //only save at this point if the quote item has been saved, otherwise wait until the quote item is saved
        var data = this.state.editNotes;

        if (data.id > 0) {
            this.saveQuoteNotes(data.rowIndex, data.notes, 2);
        } else {
            //reset
            var editNotes: EditNotes = {
                heading: "",
                parentIndex: 0,
                rowIndex: 0,
                id: 0,
                itemId: 0,
                item: "",
                notes: ""
            }

            this.setState({ editNotes: editNotes, showEditNotesModal: false });
        }
    }

    async saveQuoteNotes(itemIndex: number, updatedNotes: string, noteType: number) {
        //noteType => 1 for Quote Notes and 2 for Notes
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //save notes
        var quote = this.state.quoteDetails;
        var quoteItem = quote.jobQuoteItems[itemIndex];
        if (quoteItem) {
            var existQuoteNotes = quoteItem.quoteNote;
            var existNotes = quoteItem.notes;

            var quoteItemNotes: QuoteItemNotes = {
                id: quoteItem.id,
                jobId: quote.jobId,
                itemId: quoteItem.itemId,
                notes: noteType === 2 ? updatedNotes : existNotes,
                quoteNote: noteType === 1 ? updatedNotes : existQuoteNotes,
                subId: user.sub
            };

            axios.post('api/Job/SaveQuoteItemNotes', quoteItemNotes, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            })
            .then(res => {
                toast.success("Notes Saved");

                //reset
                var editNotes: EditNotes = {
                    heading: "",
                    parentIndex: 0,
                    rowIndex: 0,
                    id: 0,
                    itemId: 0,
                    item: "",
                    notes: ""
                }

                quoteItem.quoteNote = noteType === 1 ? updatedNotes : existQuoteNotes;
                quoteItem.notes = res.data;     //update the notes as I am adding the quote notes to the notes field

                this.setState({ quoteDetails: quote, editNotes: editNotes, showEditNotesModal: false, showQuoteNote: false, quoteNote: "", quoteNoteIndex: -1 });
            })
            .catch(error => {
                toast.error(error.message);
            });
        }
    }

    //End Notes Popup

    //Extras - Dunny Only
    //EXTRA ITEMS
    addExtraItems = (e: any, itemIndex: number) => {
        e.preventDefault();

        var quote = this.state.quoteDetails;
        var quoteItem = quote.jobQuoteItems[itemIndex];
        let extras: NewJobQuoteItemExtra =
        {
            itemId: quoteItem.typeId === 14 ? this.state.siteOfficeExtraId : quoteItem.typeId === 17 ? this.state.lunchRoomExtraId : 0,
            equipped: quoteItem.extras.equipped,
            quantity: quoteItem.extras.quantity
        };

        //quoteItem.extras;
        let isItemLarge = quoteItem.item.includes("6.0");
        let noTables = isItemLarge ? 2 : 1;
        let noChairs = quoteItem.typeId === 14 && isItemLarge ? 4 : quoteItem.typeId === 17 && isItemLarge ? 8 : quoteItem.typeId === 17 ? 4 :  2;

        var canEdit = quoteItem.statusId == 1 || quoteItem.statusId == 2;

        this.setState({ showExtraItems: true, editExtraItems: canEdit, extraIndex: itemIndex, itemDescription: quoteItem.itemDescription, tables: noTables, chairs: noChairs, extras: extras });
    }

    hideExtraItems = () => {
        var extra: NewJobQuoteItemExtra = {
            itemId: -1,
            quantity: 0,
            equipped: false
        };
        this.setState({ showExtraItems: false, editExtraItems: false, extraIndex: -1, itemDescription: "", tables: 1, chairs: 2, extras: extra });
    }

    updateExtraItems = (extraItems: NewJobQuoteItemExtra) => {
        this.setState({ extras: extraItems });
    }

    //delivery address isn't used here as it only gets set when the item is scheduled
    saveExtraItems = (deliveryAddress: DeliveryAddress) => {
        var quote = this.state.quoteDetails;
        var quoteItem = quote.jobQuoteItems[this.state.extraIndex];
        var extras = this.state.extras;

        //update quote
        quoteItem.extras.itemId = extras.itemId;
        quoteItem.extras.quantity = extras.quantity;
        quoteItem.extras.equipped = extras.equipped;

        //reset as cannot save from this screen - shouldn't be called
        var extra: NewJobQuoteItemExtra = {
            itemId: -1,
            quantity: 0,
            equipped: false
        };

        this.setState({ showExtraItems: false, editExtraItems: false, extraIndex: -1, itemDescription: "", tables: 1, chairs: 2, extras: extra });
        this.calcQuotePrice(quote, quoteItem);
    }

    //END EXTRA ITEMS

    //EXTRA CROSSOVER SECTIONS
    calculateCrossoverQuantity = (e: any, itemIndex: number) => {
        e.preventDefault();
        var quote = this.state.quoteDetails;
        var quoteItem = quote.jobQuoteItems[itemIndex];
        var quoteItemExtra = quoteItem.extras;

        //calculate total length
        var extraQty = quoteItemExtra ? quoteItemExtra.quantity : 0;
        var totalCrossoverLength = (quoteItem.quantity * 4.8) + (extraQty * 0.3);

        var extraCrossoverSection: JobQuoteExtraSection = {
            totalLength: totalCrossoverLength,
            crossoverQuantity: quoteItem.quantity,
            sectionQuantity: extraQty,
            totalCrossoverLength: totalCrossoverLength.toFixed(1)
        };

        var canEdit = quoteItem.statusId == 1 || quoteItem.statusId == 2;

        this.setState({ showExtraSection: true, extraIndex: itemIndex, extraSection: extraCrossoverSection, editExtraItems: canEdit });
    }

    updateExtraSection = (extraCrossoverSection: JobQuoteExtraSection) => {
        var totalCrossoverLength = (extraCrossoverSection.crossoverQuantity * 4.8) + (extraCrossoverSection.sectionQuantity * 0.3);
        extraCrossoverSection.totalCrossoverLength = totalCrossoverLength.toFixed(1);

        this.setState({ extraSection: extraCrossoverSection });
    }

    hideExtraSection = () => {
        var extraCrossoverSection: JobQuoteExtraSection = {
            totalLength: 0,
            crossoverQuantity: 0,
            sectionQuantity: 0,
            totalCrossoverLength: "0.0"
        };

        this.setState({ showExtraSection: false, extraIndex: -1, extraSection: extraCrossoverSection, editExtraItems: false });
    }

    saveCrossoverTotal = () => {
        var quote = this.state.quoteDetails;
        var quoteItem = quote.jobQuoteItems[this.state.extraIndex];

        //update quote
        quoteItem.extras.itemId = quoteItem.itemId;
        quoteItem.extras.quantity = this.state.extraSection.sectionQuantity;
        quoteItem.quantity = this.state.extraSection.crossoverQuantity;

        //reset
        var extraCrossoverSection: JobQuoteExtraSection = {
            totalLength: 0,
            crossoverQuantity: 0,
            sectionQuantity: 0,
            totalCrossoverLength: "0.0"
        };

        this.setState({ showExtraSection: false, extraIndex: -1, extraSection: extraCrossoverSection, editExtraItems: false });

        this.calcQuotePrice(quote, quoteItem);
    }
    //END EXTRA CROSSOVER SECTIONS

    //INVOICE DESCRIPTION
    editInvoiceDescription = (e: any, itemIndex: number) => {
        e.preventDefault();

        var quote = this.state.quoteDetails;
        var quoteItem = quote.jobQuoteItems[itemIndex];

        var readonly = (quoteItem.statusId == 1 || quoteItem.statusId == 2) ? false : true;

        this.setState({ showInvoiceDescription: true, editTrolleyReadOnly: readonly, extraIndex: itemIndex, jobQuoteItemId: quoteItem.id, existInvoiceDescription: quoteItem.invoiceDescription, trolley: quoteItem.trolley });
    }

    hideInvoiceDescription = () => {
        this.setState({ showInvoiceDescription: false, extraIndex: -1, jobQuoteItemId: 0, existInvoiceDescription: "", trolley: false });
    }

    updateDeliveryAddress = (updatedDelAddress: DeliveryAddress) => {
        //not used
    }

    clearDeliveryAddress = () => {
        //not used
    }

    updateInvoiceDescription = (updatedInvDesc: string) => {
        this.setState({ existInvoiceDescription: updatedInvDesc });
    }

    updateTrolley = (updatedTrolley: boolean) => {
        this.setState({ trolley: updatedTrolley });
    }

    //Delivery Address can't be updated here, has to wait for the item to be scheduled
    saveInvoiceDescription = () => {
        var quote = this.state.quoteDetails;
        var quoteItem = quote.jobQuoteItems[this.state.extraIndex];

        quoteItem.invoiceDescription = this.state.existInvoiceDescription;
        quoteItem.trolley = this.state.trolley;
        
        this.setState({ showInvoiceDescription: false, quoteDetails: quote, extraIndex: -1, jobQuoteItemId: -1, existInvoiceDescription: "", trolley: false });
        this.calcQuotePrice(quote, quoteItem);
    }
    //END INVOICE DESCRIPTION

    //SCHEDULE ON HOLD JOB
    scheduleOnHoldJob = (e: any, itemIndex: number, onHoldJob: boolean) => {
        e.preventDefault();

        this.scheduleOnHoldQuotedJob(itemIndex, onHoldJob);
    }

    scheduleOnHoldQuotedJob = (itemIndex: number, onHoldJob: boolean) => {
        var quote = this.state.quoteDetails;
        var quoteItem = quote.jobQuoteItems[itemIndex];
        if (quoteItem.isDirty || quote.isDirty) {
            //save the job
            this.saveQuote("schedule", onHoldJob, itemIndex);
        } else {
            this.schedOnHoldQuotedJob(quote, quoteItem, onHoldJob);
        }
    }

    schedOnHoldQuotedJob = async (quote: JobQuoteDetails, quoteItem: JobQuoteItems, onHoldJob: boolean) => {
        if (await this.validateScheduleJob(quote, quoteItem)) {
            var schItem: ScheduleItemDetail = {
                jobId: this.props.jobId,
                jobQuoteItemId: quoteItem.id,
                item: quoteItem.item,
                itemTypeId: quoteItem.typeId,
                installOnly: quoteItem.installOnly,
                isEvent: quoteItem.isEvent || this.state.quoteDetails.isEvent,
                needsPickup: this.state.scheduleJobNeedsPickup || this.state.quoteDetails.isEvent,
                hirePeriod: quoteItem.hirePeriod,
                frequencyId: quoteItem.frequencyId,
                customerAccountTypeId: this.state.customerAccountTypeId,
                customerLinkedToReckon: this.state.customerLinkedToReckon,
                siteContact: (quote.siteContactName ?? "") + " " + (quote.siteContactPhone ?? ""),
                jobOnHold: onHoldJob
            };

            this.setState({ showScheduleJob: true, scheduleItemDetail: schItem });
        } else {
            toast.error("Please fix validation errors before scheduling item!");
        }
    }

    resetScheduleItemDetail = () => {
        var schItem: ScheduleItemDetail = {
            jobId: this.props.jobId,
            jobQuoteItemId: 0,
            item: "",
            itemTypeId: -1,
            installOnly: false,
            isEvent: false,
            needsPickup: this.state.scheduleJobNeedsPickup,
            hirePeriod: -1,
            frequencyId: -1,
            customerAccountTypeId: this.state.customerAccountTypeId,
            customerLinkedToReckon: this.state.customerLinkedToReckon,
            siteContact: "",
            jobOnHold: false
        };

        return schItem;
    }

    hideScheduleOnHoldJob = () => {
        this.setState({ showScheduleJob: false });
        var resetSchItem = this.resetScheduleItemDetail();

        this.setState({ scheduleItemDetail: resetSchItem });
    }

    saveScheduleOnHoldJob = () => {
        this.setState({ showScheduleJob: false });

        var resetSchItem = this.resetScheduleItemDetail();
        this.setState({ scheduleItemDetail: resetSchItem });

        this.getQuote();
    }

    validateScheduleJob = async (quote: JobQuoteDetails, quoteItem: JobQuoteItems) => {
        //need to make sure we have a site contact name and phone number, doors facing selected (for certain items)
        let errors: any = {};
        let formIsValid = true;

        if (quote.siteContactName == "" || quote.siteContactPhone == "") {
            formIsValid = false;
            errors["siteContact"] = "Site Contact Name and Phone is required";
        }

        if (quoteItem.truckDoorsId < 1 && quoteItem.isEws && quoteItem.typeId != 21 && quote.customerPickingUp === 0 ) {
            errors["quoteItems"] = "Please select Truck Doors Direction before scheduling!";
            formIsValid = false;
        }

        //check power poles
        if (quoteItem.typeId === 23) {
            var valid = await this.checkPowerPoleQuestions(quoteItem.itemId, true);
            if (!valid) {
                let isUnderground = quoteItem.item.toLowerCase().includes("underground");
                var extraNote = isUnderground ? "(Must have pit on site)" : "(Must have clear line of sight)";
                errors["quoteItems"] = "Power Pole Questions must be answered " + extraNote + " before scheduling!";
                formIsValid = false;
            }
        }

        //check epa jobs have had questions answered
        if (quoteItem.productGroupId === 6) {
            if (!quoteItem.epaQuestionsAnswered) {
                errors["quoteItems"] = "EPA Questions must be answered before scheduling!";
                formIsValid = false;
            }
        }

        this.setState({ errors: errors });

        return formIsValid;
    }

    //END SCHEDULE ON HOLD JOB

    //POWER POLE QUESTIONS
    viewPowerPoleQuestions = (e: any, itemIndex: number) => {
        e.preventDefault();

        var quote = this.state.quoteDetails;
        var quoteItem = quote.jobQuoteItems[itemIndex];
        var canEdit = quoteItem.statusId == 1 || quoteItem.statusId == 2;

        this.setState({ showPowerPoleQuestions: true, powerPoleItemId: quoteItem.itemId, powerPoleCanEdit: canEdit, calculatorIndex: itemIndex });
    }

    hidePowerPoleQuestions = () => {
        this.setState({ showPowerPoleQuestions: false, powerPoleItemId: -1, powerPoleCanEdit: false, calculatorIndex: -1 });
    }

    savePowerPoleQuestions = () => {
        var quote = this.state.quoteDetails;
        var quoteItem = quote.jobQuoteItems[this.state.calculatorIndex];
        this.setState({ showPowerPoleQuestions: false, powerPoleItemId: -1, powerPoleCanEdit: false, calculatorIndex: -1 });
        this.calcQuotePrice(quote, quoteItem);
    }
    //END POWER POLE QUESTIONS

    //EPA QUESTIONS
    viewEpaQuestions = (e: any, itemIndex: number) => {
        e.preventDefault();

        var quote = this.state.quoteDetails;
        var quoteItem = quote.jobQuoteItems[itemIndex];
        var canEdit = quoteItem.statusId == 1 || quoteItem.statusId == 2;

        this.setState({ showEpaQuestions: true, jobQuoteItemId: quoteItem.id, itemId: quoteItem.itemId, itemDescription: quoteItem.item, itemTypeId: quoteItem.typeId, powerPoleCanEdit: canEdit, calculatorIndex: itemIndex });
    }

    hideEpaQuestions = () => {
        this.setState({
            showEpaQuestions: false, jobQuoteItemId: -1, itemId: 0, itemDescription: "", itemTypeId: -1, powerPoleCanEdit: false, calculatorIndex: -1
        });
    }

    saveEpaQuestions = (tankLidExposed: boolean, confinedSpace: boolean, weekendJob: boolean, emergencySameDayJob: boolean, updatedInvoiceDescription: string, updatedIncludeGreaseTrap: boolean) => {
        var quote = this.state.quoteDetails;
        var quoteItem = quote.jobQuoteItems[this.state.calculatorIndex];
        quoteItem.invoiceDescription = updatedInvoiceDescription;
        quoteItem.trolley = updatedIncludeGreaseTrap;

        quoteItem.tankLidExposed = tankLidExposed;
        if (quoteItem.typeId === 58) {
            quoteItem.extraHours = tankLidExposed ? 0 : 0.5;        //need to charge an extra half an hour to locate tank lid
        }
        quoteItem.weekendJob = weekendJob;
        quoteItem.emergencySameDayJob = emergencySameDayJob;
        quoteItem.epaQuestionsAnswered = true;

        this.setState({
            showEpaQuestions: false, jobQuoteItemId: -1, itemId: 0, itemDescription: "", itemTypeId: -1, powerPoleCanEdit: false, calculatorIndex: -1
        });

        if (quoteItem.typeId === 61) {
            quoteItem.confinedSpaceAmount = confinedSpace ? this.state.epaConfinedSpacePrice : 0;
            quoteItem.cleaningFee = weekendJob ? this.state.weekendRate : emergencySameDayJob ? this.state.sameDayRate : 0;

            //calculate amount field
            var itemAmount = quoteItem.initialHire + quoteItem.travelAmount + quoteItem.cleaningFee + quoteItem.trenchFee + quoteItem.confinedSpaceAmount + quoteItem.sampleTestingAmount + quoteItem.wasteDisposalAmount + quoteItem.fuelSurchargeAmount;
            quoteItem.amount = parseFloat(itemAmount.toFixed(2));

            var total = this.calculateTotal(quote.jobQuoteItems);
            quote.totalQuotedAmount = parseFloat(total.toFixed(2));
            quote.totalQuotedAmountFormatted = total.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });
            quote.totalInvoiceAmount = (total * 1) + (quote.totalInvoiceExtraAmount * 1);
            quote.totalInvoiceAmountFormatted = quote.totalInvoiceAmount.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });

            this.setState({ quoteDetails: quote });
        } else {
            this.calcQuotePrice(quote, quoteItem);
        }
    }

    //END EPA QUESTIONS

    //TROLLEY - add trolley to the job
    viewTrolley = (e: any, itemIndex: number) => {
        e.preventDefault();

        var quote = this.state.quoteDetails;
        var quoteItem = quote.jobQuoteItems[itemIndex];
        var canEdit = quoteItem.statusId == 1 || quoteItem.statusId == 2;
        
        this.setState({ showExtraTrolley: true, extraTrolley: quoteItem.trolley, extraIndex: itemIndex, editExtraItems: canEdit, itemTypeId: quoteItem.typeId });
    }

    updateExtraTrolley = (trolley: boolean) => {
        this.setState({ extraTrolley: trolley });
    }

    hideExtraTrolley = () => {
        this.setState({ showExtraTrolley: false, extraTrolley: false, extraIndex: -1, editExtraItems: true, itemTypeId: -1 });
    }

    saveExtraTrolley = () => {
        var quote = this.state.quoteDetails;
        var quoteItem = quote.jobQuoteItems[this.state.extraIndex];
        quoteItem.trolley = this.state.extraTrolley;

        this.setState({ showExtraTrolley: false, extraTrolley: false, extraIndex: -1, editExtraItems: true, itemTypeId: -1 });
        this.calcQuotePrice(quote, quoteItem);
    }
    //END TROLLEY

    //EXTRA INVOICE ITEMS
    viewExtraInvoiceItems = (e: any) => {
        e.preventDefault();

        this.setState({ extraInvoiceItemQuoteId: this.state.quoteDetails.id, showExtraInvoiceItems: true });
    }

    hideExtraInvoiceItems = () => {
        this.setState({ extraInvoiceItemQuoteId: 0, showExtraInvoiceItems: false });
    }

    saveExtraInvoiceItems = (totalExtraInvoiceItem: number) => {
        var quote = this.state.quoteDetails;
        var quoteTotal = quote.totalQuotedAmount;
        quote.totalInvoiceExtraAmount = totalExtraInvoiceItem;
        quote.totalInvoiceExtraAmountFormatted = totalExtraInvoiceItem.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });   
        quote.totalInvoiceAmount = (quoteTotal * 1) + (quote.totalInvoiceExtraAmount * 1);
        quote.totalInvoiceAmountFormatted = quote.totalInvoiceAmount.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });

        this.setState({ quoteDetails: quote, extraInvoiceItemQuoteId: 0, showExtraInvoiceItems: false });
    }
    //END EXTRA INVOICE ITEMS

    copyJob = () => {
        this.props.copyJob();
    }

    handleImportFile = (e: any) => {
        var files = e.target.files;
        //this.setState({ uploadedFiles: e.target.files });
        this.uploadPlans(files);
    }

    async uploadPlans(files: File[]) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //save photos
        const data = new FormData()
        data.append('jobId', this.props.jobId.toString());
        data.append('subId', user.sub);
        for (var i = 0; i < files.length; i++) {
            data.append('plan', files[i]);
        }

        //save photos
        axios.post('api/Job/SaveJobQuotePlans', data, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Plan/s have been saved");
                this.getQuotePlans();
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    //delete job plan
    deleteJobPlan = (id: number) => {
        this.setState({ showDeletePlan: true, deletePlanId: id });
    }

    hideDeleteJobPlan = () => {
        this.setState({ showDeletePlan: false, deletePlanId: 0 });
    }

    saveDeleteJobPlan = () => {
        this.deletePlan();
    }

    async deletePlan() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        let planId = this.state.deletePlanId;
        var deleteplan = {
            id: planId,
            subId: user.sub
        }

        var plans = this.state.plans;

        axios.post('api/Job/DeleteJobPlan', deleteplan, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Plan Deleted");
            var planIndex = plans.findIndex(p => p.id == planId);
            plans.splice(planIndex, 1);
            this.setState({ plans: plans, showDeletePlan: false, deletePlanId: 0 });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    //download job plan
    downloadPlan = (e: any, id: number) => {
        e.preventDefault();
        this.getPlanFile(id);
    }

    async getPlanFile(id: number) {
        const token = await authService.getAccessToken();

        axios('api/Job/GetJobPlans?Id=' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'GET',
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            //var fileName = res.getResponseHeader('content-disposition').split('filename=')[1].split(';')[0];
            var fileheader = res.headers["content-disposition"];
            var filename = "plans.pdf";
            if (fileheader) {
                filename = fileheader.split('filename=')[1].split(';')[0];
                filename = filename.replaceAll('"', '');
            }
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    printJobQuoteAcceptance = () => {
        var url = "/job/" + this.props.jobId + "/report/JobQuoteAcceptance";
        window.open(url, '_blank');
    }

    printJobQuote = async () => {
        //validate data before printing runsheets
        //if list is filtered we only want to print that list so only validate that list
        //ignore any items that cannot be updated
        if (await this.validate()) {
            //save version history
            this.saveVersionHistory();

            var reportName = this.props.systemCompanyId === 3 && this.props.jobTypeId === 2 ? "JobRequest" : this.props.systemCompanyId === 3 ? "JobQuoteRequest" : "JobQuote";

            var url = "/job/" + this.props.jobId + "/report/" + reportName;
            window.open(url, '_blank');
        } else {
            toast.error("Please fix validation errors and try Saving again!");
        }
    }

    printJobQuoteSampleTesting = async () => {
        var url = "/job/" + this.props.jobId + "/report/JobQuoteRequestSampleTesting";
        window.open(url, '_blank');
    }

    async saveVersionHistory() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var saveVersion = {
            jobQuoteId: this.state.quoteDetails.id,
            subId: user.sub
        };

        axios.post('api/Job/SaveQuoteVersion', saveVersion, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            //nothing at this stage
        });
    }

    //MOVE ROW
    private handleDragStart = (event: React.DragEvent<HTMLDivElement>, oldIndex: number) => {
        event.dataTransfer.setData('text', oldIndex.toString());
    }

    private enableDropping = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
    }

    private handleDrop = (event: React.DragEvent<HTMLDivElement>, newIndex: number) => {
        const oldIndexText = event.dataTransfer.getData('text');
        var oldIndex = parseInt(oldIndexText);
        this.onSortEnd(oldIndex, newIndex);
    }

    private onSortEnd = (oldIndex: number, newIndex: number) => {
        var jobQuote = this.state.quoteDetails;
        var jobQuoteItems = jobQuote.jobQuoteItems;

        var hasBlankRow = this.props.jobTypeId === 1 || this.props.jobTypeId === 3;
        var quoteLength = hasBlankRow ? jobQuoteItems.length - 1 : jobQuoteItems.length;

        if (oldIndex != newIndex && ((hasBlankRow && oldIndex != quoteLength && newIndex != quoteLength) || !hasBlankRow)) {
            //only move if not moving to same location or to blank row
            jobQuoteItems.splice(newIndex, 0, jobQuoteItems.splice(oldIndex, 1)[0]);

            //loop through the items and update the order
            var itemOrder = 1;  //not used for cancelled items
            for (var i = 0; i < jobQuoteItems.length; i++) {
                jobQuoteItems[i].itemIndex = (i);
                if (jobQuoteItems[i].status !== "Cancelled") {
                    //need to ignore cancelled items
                    jobQuoteItems[i].itemOrder = (itemOrder);
                    itemOrder += 1;
                }
            }

            this.saveQuote("", false, -1);
        }
    };
    //END MOVE ROW

    validate = async () => {
        let fields = this.state;
        let errors: any = {};
        let formIsValid = true;

        //if (fields.quoteDetails.requireSiteVisit && fields.quoteDetails.siteVisitPerson < 0 ) {
        //    formIsValid = false;
        //    errors["siteVisitPerson"] = "Site Visit Person is required";
        //}

        //check to make sure there is only one power pole item
        var ppItems = fields.quoteDetails.jobQuoteItems.filter(i => i.typeId === 23 && i.statusId === 1);
        if (ppItems.length > 1) {
            formIsValid = false;
            errors["quoteItems"] = "ONLY 1 Power Pole Item allowed per quote! Please remove any extra power poles!";
            this.setState({ errors: errors });
            return formIsValid;
        }

        let items = fields.quoteDetails.jobQuoteItems;
        var rowNumber = 0;

        var errorString = "Please enter the following values: ";
        var error = false;
        //last row is a blank new row so ignore
        for (var i = 0; i < items.length - 1; i++) {
            //update the row number depending on whether we have filtered out cancelled items
            if ((this.state.showCancelledItems) || (!this.state.showCancelledItems && items[i].status != "Cancelled") ) {
                rowNumber += 1;
            } 
            //ignore any installed, pickedup, cancelled items
            if (items[i].statusId == 1 || items[i].statusId == 2) {
                var newErrorString = "";
                if (items[i].itemId < 0) {
                    newErrorString += " Item, ";
                    error = true;
                }
                if (!items[i].callout && items[i].hirePeriod <= 0) {
                    newErrorString += " Hire Period, ";
                    error = true;
                }

                if (items[i].itemId > 0 && items[i].isVoid && items[i].size <= 0) {
                    newErrorString += " Void Size, ";
                    error = true;
                }

                if (items[i].itemId > 0 && items[i].isTower && items[i].size <= 0) {
                    newErrorString += " Tower Height, ";
                    error = true;
                }

                if (items[i].typeId === 38 && (!items[i].extraHours || items[i].extraHours <= 0)) {
                    newErrorString += " Hours, ";
                    error = true;
                }

                if (items[i].productGroupId === 6 && (!items[i].size || items[i].size <= 0)) {
                    newErrorString += " Size, ";
                    error = true;
                }

                if (items[i].quantity <= 0) {
                    newErrorString += " Quantity, ";
                    error = true;
                }
                if (items[i].amount <= 0) {
                    newErrorString += " Amount, ";
                    error = true;
                }

                let isElite = items[i].item.toLowerCase().includes("elite");
                if (items[i].truckId < 1 && items[i].isEws && items[i].typeId != 21) {
                    newErrorString += " Truck, ";
                    error = true;
                } else if (isElite && items[i].truckId != 1) {
                    newErrorString += " Elite Units MUST use Tilt Truck, ";
                    error = true;
                }

                //check power poles
                if (items[i].typeId === 23) {
                    var valid = await this.checkPowerPoleQuestions(items[i].itemId, false);
                    if (!valid) {
                        newErrorString += " Power Pole Questions must be answered, ";
                        error = true;
                    }
                }

                //check truck hours for epa jobs
                if (items[i].typeId === 61) {
                    if (items[i].extraHours < 1) {
                        newErrorString += " Truck Hours, ";
                        error = true;
                    }
                    if (items[i].initialHire <= 0 ) {
                        newErrorString += " Initial Service Price, ";
                        error = true;
                    }
                }

                //overhire rate can be $0 for install only items
                var installOnly = false;
                if (items[i].itemId > 0) {
                    //find item option
                    var itemRow = this.state.itemOptions.find(io => io.id === items[i].itemId);
                    if (itemRow) {
                        installOnly = itemRow.installOnly;
                    }
                }

                //Callouts, Events and Install Only items don't need overhire rates
                if (!items[i].callout && items[i].overhireRate <= 0 && items[i].extendable && !installOnly && !this.state.quoteDetails.isEvent) {
                    newErrorString += " Overhire Rate, ";
                    error = true;
                }

                if (!items[i].callout && items[i].amount > 0 && items[i].overhireRate > 0) {
                    //check to make sure if an amount is entered that there is also an overhire rate and vice versa
                    var amount = items[i].amount * 1;//parseInt(items[i].amount, 10);
                    var overhire = items[i].overhireRate * 1; //parseInt(items[i].overhireRate, 10);

                    if (amount === 0 && overhire > 0) {
                        newErrorString += " Amount cannot be $0, ";
                        error = true;
                    }
                }

                if (newErrorString != "") {
                    errorString += "\n"
                    errorString += "Row " + rowNumber + ": " + newErrorString;
                    errorString = errorString.substring(0, errorString.length - 2);
                }
            }
        }
        if (error) {
            formIsValid = false;
            errors["quoteItems"] = errorString;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    checkPowerPoleQuestions = async (itemId: number, isScheduling: boolean) => {
        const token = await authService.getAccessToken();

        let result = await axios.get('api/Job/ValidatePowerPoleQuestions?jobId=' + this.props.jobId + '&itemId=' + itemId + '&isScheduling=' + isScheduling, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        if (result.data) {
            return true;
        }

        return false;
    }

    submit = (e: any) => {
        e.preventDefault();
        this.checkQuote("");
    }

    checkQuote = async (calledFrom: string) => {
        let valid = await this.validate();

        if (!valid) {
            toast.error("Please fix validation errors before Saving!");
        } else {
            if (this.state.saveDisabled) {
                return;
            }
            this.setState({ saveDisabled: true });

            this.saveQuote(calledFrom, false, -1);
        }
    }

    saveQuote = async (calledFrom: string, onHoldJob: boolean, scheduleIndexId: number) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var jobQuote = this.state.quoteDetails;

        //remove blank row from item list
        var itemCopy = _.cloneDeep(jobQuote.jobQuoteItems);
        if (this.props.jobTypeId === 1 || this.props.jobTypeId === 3) {
            itemCopy.pop();
        }

        //remove any cancelled items with an id of 0 so we don't send bad data to the database
        for (var i = 0; i < itemCopy.length; i++) {
            if (itemCopy[i].status == "Cancelled" && itemCopy[i].id == 0) {
                itemCopy.splice(i, 1);
            }
            //update custom hire period to save days not weeks
            itemCopy[i].hirePeriod = itemCopy[i].customHirePeriod && itemCopy[i].invoicePeriodTypeId === 1 ? itemCopy[i].hirePeriod * 7 : itemCopy[i].hirePeriod;
        }

        var quote = {
            jobId: jobQuote.jobId,
            quoteNo: jobQuote.quoteNo,
            quoteNotes: jobQuote.quoteNotes,
            manualQuoteNumber: jobQuote.manualQuoteNumber,
            requireSiteVisit: jobQuote.requireSiteVisit,
            siteVisitPerson: jobQuote.requireSiteVisit ? jobQuote.siteVisitPerson : 0,
            siteContactName: jobQuote.siteContactName,
            siteContactPhone: jobQuote.siteContactPhone,
            showSiteVisitNote: jobQuote.showSiteVisitNote,
            customerPickingUp: jobQuote.customerPickingUp,
            jobQuoteItems: itemCopy,
            fenceArea: this.state.fenceArea,
            subId: user.sub
        }

        //save
        axios.post('api/Job/SaveQuote', quote, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (calledFrom === "schedule") {
                //need to schedule the item now that we have saved it
                var quoteItem = itemCopy[scheduleIndexId];
                quoteItem.isDirty = false;
                this.schedOnHoldQuotedJob(jobQuote, quoteItem, onHoldJob);
            } else {
                toast.success("Quote Saved");
                this.getQuote();
            }
            
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderQuote();


        return (<div>
            {contents}
        </div>);
    }

    renderQuote = () => {
        var showButton = false;
        if (!this.state.quoteDetails.quoteNo) {
            showButton = true;
        }

        let filteredItems = this.state.quoteDetails.jobQuoteItems.filter(data =>
            data.status != "Cancelled"
        )
        let quoteItems = this.state.showCancelledItems ? this.state.quoteDetails.jobQuoteItems : filteredItems;
        var lastRowIndex = this.props.jobTypeId === 2 ? quoteItems.length : quoteItems.length - 1;
        let hasEpaItems = quoteItems.filter(i => i.productGroupId === 6).length > 0;
        let hasEpaOtherItems = quoteItems.filter(i => i.typeId === 61).length > 0;
        let cancelOptions = this.state.cancelOptions;
        let confirmDeletePlan = <ConfirmPopups heading="Delete Plan" text="Are you sure you want to delete this plan?" showConfirmModal={this.state.showDeletePlan} hideConfirmModal={this.hideDeleteJobPlan} saveConfirmModal={this.saveDeleteJobPlan} />

        let notesPopup = <NotesPopup showEditNotesModal={this.state.showEditNotesModal} editNotes={this.state.editNotes} hideNotes={this.hideNotes} updateNotes={this.updateNotes} saveNotes={this.saveNotes} />
        let quoteNotePopup = <QuoteNotePopup showModal={this.state.showQuoteNote} notes={this.state.quoteNote} hideModal={this.hideQuoteNote} update={this.updateQuoteNote} saveModal={this.saveQuoteNote} />
        let calculatorPopup = <JobQuoteCalculatorModal showModal={this.state.showCalculator} starterBayOptions={this.state.starterBayOptions} liftOptions={this.state.liftOptions} kwikstageInstalledForOptions={this.state.kwikstageInstalledForOptions} statusId={this.state.calculatorStatusId} kwikstageItem={this.state.calculatorKwikstageItem} items={this.state.calculatorItems} editOnly={false} canEditBays={this.state.calculatorStatusId === 1 || this.state.calculatorStatusId === 2} typeId={-1} hideModal={this.hideCalculateKwikstage} update={this.updateCalculateKwikstage} updateItem={this.updateCalculatorKwikstageItem} save={this.saveCalculateKwikstage} />
        let siteNotesPopup = <QuoteSiteNotePopup showModal={this.state.showAddSiteNotes} jobQuoteId={this.state.quoteDetails.id} notes={this.state.siteNotes} hideModal={this.hideSiteNotes} update={this.updateSiteNotes} />
        //is Event is set to false here as we don't set delivery address until the item is scheduled
        let extrasPopup = <JobQuoteExtraItemModal isEvent={false} existDeliveryAddress={""} showModal={this.state.showExtraItems} extraItemOptions={this.state.extraItemOptions} itemDescription={this.state.itemDescription} itemTableDesk={this.state.tables} itemChairs={this.state.chairs} readonly={!this.state.editExtraItems} extras={this.state.extras} hideModal={this.hideExtraItems} update={this.updateExtraItems} save={this.saveExtraItems} />
        let extraSections = <JobQuoteExtraSectionData showModal={this.state.showExtraSection} crossoverTotal={this.state.extraSection} readOnly={!this.state.editExtraItems} update={this.updateExtraSection} hideModal={this.hideExtraSection} saveModal={this.saveCrossoverTotal} />
        let schOnHoldJob = <AllocateScheduleJobPopup showModal={this.state.showScheduleJob} defaultDays={this.state.defaultDays} customerNewFuelInvoice={this.state.customerNewFuelInvoice} scheduleItemDetail={this.state.scheduleItemDetail} hideModal={this.hideScheduleOnHoldJob} saveModal={this.saveScheduleOnHoldJob} />
        let powerPoleQuestions = <JobQuoteQuestionsData showModal={this.state.showPowerPoleQuestions} readOnly={!this.state.powerPoleCanEdit} jobId={this.props.jobId} itemId={this.state.powerPoleItemId} yesNoOptions={this.state.yesNoOptions} hideModal={this.hidePowerPoleQuestions} saveModal={this.savePowerPoleQuestions} />
        let extraTrolley = <JobQuoteExtraTrolleyData showModal={this.state.showExtraTrolley} readOnly={!this.state.editExtraItems} trolley={this.state.extraTrolley} isEpa={this.state.itemTypeId === 58} update={this.updateExtraTrolley} hideModal={this.hideExtraTrolley} saveModal={this.saveExtraTrolley} />
        let extraInvItems = <JobQuoteExtraInvoiceItemModal showModal={this.state.showExtraInvoiceItems} jobId={this.props.jobId} jobQuoteId={this.state.extraInvoiceItemQuoteId} hideModal={this.hideExtraInvoiceItems} save={this.saveExtraInvoiceItems} />
        let pitchHeading = "Pitch > 26";
        let jobQuoteHeading = this.props.systemCompanyId === 3 && this.props.jobTypeId === 2 ? "Print Job Request" : "Print Job Quote";
        let delAddr: DeliveryAddress = {
            deliveryAddress: "",
            deliveryAddressGooglePlaceId: "",
            deliveryAddressLatitude: 0,
            deliveryAddressLongitude: 0
        };
        let invoiceItemPopup = <JobQuoteDeliveryAddressData deliveryAddress={delAddr} showDeliveryAddress={false} invoiceDescription={this.state.existInvoiceDescription} showInvoiceDescription={true} trolleyRequired={this.state.trolley} showTrolley={false} readOnly={this.state.editTrolleyReadOnly} showModal={this.state.showInvoiceDescription} hideModal={this.hideInvoiceDescription} updateDeliveryAddress={this.updateDeliveryAddress} clearDeliveryAddress={this.clearDeliveryAddress} updateInvoiceDescription={this.updateInvoiceDescription} updateTrolley={this.updateTrolley} saveModal={this.saveInvoiceDescription} />
        let checkWalkWayPitch = <JobQuoteWalkWayModal walkWayItem={this.state.walkWayItem} canEdit={this.state.walkwayStatusId === 1 || this.state.walkwayStatusId === 2} hideModal={this.hideWalkWayPitch} showModal={this.state.showWalkwayPitch} update={this.updateWalkWayPitch} save={this.saveWalkWayPitch} />
        let fencingBracing = <JobQuoteBraceModal showModal={this.state.showFenceBracing} statusId={this.state.calculatorStatusId} hideModal={this.hideFenceBracing} save={this.saveFenceBracing} />
        let epaQuestions = <JobQuoteEpaQuestionsModalData showModal={this.state.showEpaQuestions} isReadOnly={!this.state.powerPoleCanEdit} jobId={this.props.jobId} jobQuoteItemId={this.state.jobQuoteItemId} itemId={this.state.itemId} itemTypeId={this.state.itemTypeId} item={this.state.itemDescription} hideModal={this.hideEpaQuestions} saveModal={this.saveEpaQuestions} />

        return (
            <div>
                <div className="static-modal">
                    {notesPopup}
                    {calculatorPopup}
                    {quoteNotePopup}
                    {confirmDeletePlan}
                    {siteNotesPopup}
                    {extrasPopup}
                    {powerPoleQuestions}
                    {extraTrolley}
                    {fencingBracing}
                    {epaQuestions}
                </div>
                <div>
                    {checkWalkWayPitch}
                    {extraSections}
                    {schOnHoldJob}
                    {extraInvItems}
                    {invoiceItemPopup}
                </div>
                <div className="static-modal">
                    <Modal show={this.state.showCancelModal} onHide={this.hideCancelModal}>
                        <Modal.Header className="modal__header--colour">
                            <Modal.Title>Cancel {this.state.cancelItem}</Modal.Title>
                            <button type="button" className="close" onClick={this.hideCancelModal}>&times;</button>
                        </Modal.Header>
                        <Modal.Body>
                            <label className="input-group" htmlFor="cancelReason">
                                <span className="label">Reason</span>
                                <select className="select" id="cancelReason" name="cancelReason" value={this.state.cancelReasonId} onChange={(e) => this.handleCancelReasonChange(e)} >
                                    <option defaultValue="-1"></option>
                                    {cancelOptions.map(reason =>
                                        <option key={reason.id} value={reason.id}>{reason.name}</option>
                                    )}
                                </select>
                            </label>
                            <span className="label errors">{this.state.errors["cancelReason"]}</span>
                        </Modal.Body>

                        <Modal.Footer>
                            <button className="popup-button--yes" onClick={this.saveCancel}>Save</button>
                        </Modal.Footer>
                    </Modal>
                </div>
                <div className={showButton ? "" : "hidden"}>
                    <button className="defaultbutton defaultbutton__small form-margin" onClick={this.createQuote} type="button">New Quote</button>
                </div>
                <div className={showButton ? "hidden" : ""}>
                    <div className="makeitflexspacebetween">
                        <div>
                            <div>
                                <label className="input-group--inline" htmlFor="quoteNo">
                                    <span className="label label--inline">Quote No</span>
                                    <input className="input" type="text" id="quoteNo" name="quoteNo" value={this.state.quoteDetails.quoteNo} onChange={(e) => this.handleChange(e)} disabled></input>
                                </label>

                                <label className="input-group--inline" htmlFor="manualQuoteNumber">
                                    <span className="label label--inline">Manual Quote No</span>
                                    <input className="input job__quoteNoSmall" type="text" id="manualQuoteNumber" name="manualQuoteNumber" value={this.state.quoteDetails.manualQuoteNumber} onChange={(e) => this.handleChange(e)}></input>
                                </label>
                                <label className="input-group--inline job__checkboxPosition" htmlFor="showCancelledItems">
                                    <span className="label label--inline">Show Cancelled Items </span>
                                    <input type="checkbox" name="showCancelledItems" id="showCancelledItems" checked={this.state.showCancelledItems} onChange={(e) => this.handleCheckboxChange(e)}></input>
                                </label>
                                <span className="marginLeft10">{this.state.customerAccountType}</span><span className={this.state.customerAccountTypeId === 1 ? "hidden" : ""}> - {this.state.customerAccountLimitFormatted}</span>
                            </div>
                            <div>
                                <label className="input-group--inline" htmlFor="siteContactName">
                                    <span className="label label--inline">Site Contact Name</span>
                                    <input className="input" type="text" maxLength={50} id="siteContactName" name="siteContactName" value={this.state.quoteDetails.siteContactName} onChange={(e) => this.handleChange(e)}></input>
                                </label>

                                <label className="input-group--inline" htmlFor="siteContactPhone">
                                    <span className="label label--inline">Site Contact Phone</span>
                                    <input className="input" type="text" maxLength={50} id="siteContactPhone" name="siteContactPhone" value={this.state.quoteDetails.siteContactPhone} onChange={(e) => this.handleChange(e)}></input>
                                </label>
                                <label className={this.props.systemCompanyId === 3 ? "hidden" : "input-group--inline job__checkboxPosition"} htmlFor="requireSiteVisit">
                                    <span className="label label--inline">Require Site Visit?</span>
                                    <input type="checkbox" name="requireSiteVisit" id="requireSiteVisit" checked={this.state.quoteDetails.requireSiteVisit} onChange={(e) => this.handleSiteVisitCheckboxChange(e)}></input>
                                </label>
                                <label className={this.props.systemCompanyId === 3 ? "input-group--inline" : "hidden"} htmlFor="customerPickingUp">
                                    <span className="label label--inline">Customer picking up?</span>
                                    <select className="select" id="customerPickingUp" name="customerPickingUp" value={this.state.quoteDetails.customerPickingUp} onChange={(e) => this.handleCustPickupChange(e)}>
                                        <option hidden defaultValue="-1"></option>
                                        {this.state.yesNoOptions.map(yn =>
                                            <option key={yn.id} value={yn.id}>{yn.name}</option>
                                        )};
                                    </select>
                                </label>
                                <label className="input-group--inline">
                                    <a href="#" onClick={(e) => this.viewQuoteHistory(e)}>View Quote History</a>
                                </label>
                                <span className={this.state.errors["siteContact"] ? "label errors" : "hidden"}>{this.state.errors["siteContact"]}</span>
                            </div>
                        </div>
                        <div>
                            <label className="input-group" htmlFor="quoteNotes">
                                <span className="label">Quote Notes</span>
                                <textarea className="input quote-notes--size" rows={4} id="quoteNotes" name="quoteNotes" value={this.state.quoteDetails.quoteNotes} onChange={(e) => this.handleChange(e)}></textarea>
                            </label>
                        </div>
                    </div>
                    <div className="table__minHeight overflowAuto">
                        <table className="table table__large tableColours marginTop10">
                            <thead>
                                <tr>
                                    <th className="hidden">Id</th>
                                    <th></th>
                                    <th></th>
                                    <th className={this.props.systemCompanyId === 3 ? "" : "hidden"}></th>
                                    <th className="table-input--minwidth100">Item</th>
                                    <th className={this.props.systemCompanyId === 3 ? "" : "hidden"}>Extra</th>
                                    <th></th>
                                    <th className={this.props.systemCompanyId === 2 ? "" : "hidden"}>{pitchHeading}</th>
                                    <th>Status</th>
                                    <th>Hire Period {this.props.systemCompanyId === 2 ? "(days)" : ""}</th>
                                    <th className={this.props.systemCompanyId === 3 ? "" : "hidden"}></th>
                                    <th className={this.props.systemCompanyId === 3 ? "" : "hidden"}>Maint/Hrs/ Bracing/Truck</th>
                                    <th className={this.props.systemCompanyId === 3 ? "" : "hidden"}>
                                        <div className="tooltipitem tooltipitem__right">Size /Doors Facing?
                                            <span className="tooltipitemtext tooltipitemtext__right">Which way are the doors to face? (remembering the tilt slide reverses into position)</span>
                                        </div>
                                    </th>
                                    <th className={this.props.systemCompanyId === 2 ? "" : "hidden"}>Size</th>
                                    <th className={this.props.systemCompanyId === 2 ? "" : "hidden"}>
                                        <div className="tooltipitem tooltipitem__right">Ins/Dis
                                            <span className="tooltipitemtext tooltipitemtext__right">Include Install and Dismantle Cost</span>
                                        </div>
                                    </th>
                                    <th></th>
                                    <th>Quantity</th>
                                    <th>Type</th>
                                    <th className={this.props.systemCompanyId === 3 ? "" : "hidden"}>Initial</th>
                                    <th>Travel ($)</th>
                                    <th className={this.props.systemCompanyId === 3 ? "" : "hidden"}>Clean/Connect /Callout</th>
                                    <th className={this.props.systemCompanyId === 3 ? "" : "hidden"}>Trench/Truck Hire Fee</th>
                                    <th className={this.props.systemCompanyId === 3 && hasEpaItems ? "" : "hidden"}>Confined Space</th>
                                    <th className={this.props.systemCompanyId === 3 && hasEpaItems ? "" : "hidden"}>Sample Testing</th>
                                    <th className={this.props.systemCompanyId === 3 && hasEpaItems ? "" : "hidden"}>Waste Disposal</th>
                                    <th>Fuel Surcharge($)</th>
                                    <th className={this.props.systemCompanyId === 2 ? "" : "hidden"}>Extra Hours</th>
                                    <th className="hidden">Rate ($)</th>
                                    <th className="hidden">GST ($)</th>
                                    <th>Amount ($)</th>
                                    <th>Overhire Rate ($)</th>
                                    <th className={this.props.systemCompanyId === 2 ? "" : "hidden"}>Est. Cost</th>
                                    <th className={this.props.systemCompanyId === 2 ? "" : "hidden"}>Est. Margin</th>
                                    <th className={this.props.systemCompanyId === 2 ? "" : "hidden"}>Est. Margin %</th>
                                    <th>Cancel</th>
                                    <th className="table-input--minwidth100">Notes</th>
                                </tr>
                            </thead>
                            <tbody>
                                {quoteItems.map((item, index) =>
                                    <tr key={index} draggable="true" onDragStart={(e) => this.handleDragStart(e, item.itemIndex)} onDragOver={this.enableDropping} onDrop={(e) => this.handleDrop(e, item.itemIndex)}>
                                        <td className="hidden">{item.id}</td>
                                        <td className="table__text--align">{index + 1}</td>
                                        <td className="table__text--align">
                                            <input name="showOnQuote" type='checkbox' className={lastRowIndex != index ? "input" : "hidden"} checked={item.showOnQuote} onChange={(e) => this.onCellCheckboxChange(e, item.itemIndex)} />
                                        </td>
                                        <td className={this.props.systemCompanyId === 3 ? "table__text--align" : "hidden"}>
                                            <span className="tooltipitem tooltipitem__right">
                                                <i className={lastRowIndex != index && item.id > 0 && item.typeId != 43 && (item.statusId == 1 || item.statusId == 2) ? "fa-solid fa-calendar-days alignIconCenter makeitgreen" : "hidden"} onClick={(e) => this.scheduleOnHoldJob(e, item.itemIndex, false)}></i>
                                                <span className="tooltipitemtext tooltipitemtext__right">Schedule Item</span>
                                            </span>
                                        </td>
                                        <td className="table__text--align">
                                            <select className={item.statusId == 1 || item.statusId == 2 ? "select table__select--size allocate__item--maxwidth" : "hidden"} id="itemId" name="itemId" value={item.itemId} onChange={(e) => this.onCellItemChange(e, lastRowIndex == index, item.itemIndex)} onBlur={(e) => item.itemId === 4 ? this.calculateKwikstage(e, item.itemIndex) : this.checkWalkWayPitch(e, item.itemIndex)} disabled={item.statusId == 1 || item.statusId == 2 ? false : true}>
                                                <option hidden defaultValue="-1"></option>
                                                {this.state.itemOptions.map(item =>
                                                    this.state.quoteDetails.isEvent || (!this.state.quoteDetails.isEvent && item.typeId != 33 && item.typeId != 42) ?
                                                        <option key={item.id} value={item.id}>{item.name}</option>
                                                    : ""
                                                )};
                                            </select>
                                            {item.statusId == 1 || item.statusId == 2 ? "" : item.invoiceDescription != "" ? item.invoiceDescription : item.item}
                                        </td>
                                        <td className={this.props.systemCompanyId === 3 ? "table__text--align" : "hidden"}>
                                            <a className={item.typeId === 14 || item.typeId === 17 ? "icon--cellwidth tooltipitem tooltipitem__right" : "hidden"} href="#" onClick={(e) => this.addExtraItems(e, item.itemIndex)}>
                                                <span className={"fa-solid fa-circle-plus edit--icon alignIconCenter" + (item.extras.quantity > 0 || item.extras.equipped ? " makeitgreen" : "")}></span>
                                                <span className="tooltipitemtext tooltipitemtext__right">Add equipment and/or extra Table/Desk and Chairs</span>
                                            </a>
                                            <a className={item.typeId === 23 ? "icon--cellwidth tooltipitem tooltipitem__right" : "hidden"} href="#" onClick={(e) => this.viewPowerPoleQuestions(e, item.itemIndex)}>
                                                <span className="fa-solid fa-circle-question edit--icon alignIconCenter makeitgreen"></span>
                                                <span className="tooltipitemtext tooltipitemtext__right">Answer Pole Pole Questions</span>
                                            </a>
                                            <a className={item.typeId === 27 ? "icon--cellwidth tooltipitem tooltipitem__right" : "hidden"} href="#" onClick={(e) => this.calculateCrossoverQuantity(e, item.itemIndex)}>
                                                <span className={"fa-solid fa-circle-plus edit--icon alignIconCenter" + (item.extras.quantity > 0 ? " makeitgreen" : "")}></span>
                                                <span className="tooltipitemtext tooltipitemtext__right">Calculate Crossover Sections</span>
                                            </a>
                                            <a className={item.typeId === 25 || item.typeId === 29 || item.typeId === 44 ? "icon--cellwidth tooltipitem tooltipitem__right" : "hidden"} href="#" onClick={(e) => this.viewTrolley(e, item.itemIndex)}>
                                                <span className={"fa-solid fa-circle-plus edit--icon alignIconCenter" + (item.trolley ? " makeitgreen" : "")}></span>
                                                <span className="tooltipitemtext tooltipitemtext__right">Add a Trolley to the job</span>
                                            </a>
                                            <a className={(item.isEvent || item.typeId === 52) && item.id > 0 ? "icon--cellwidth tooltipitem tooltipitem__right" : "hidden"} href="#" onClick={(e) => this.editInvoiceDescription(e, item.itemIndex)}>
                                                <span className={"fa-solid fa-circle-plus edit--icon alignIconCenter " + (item.invoiceDescription != "" ? " makeitgreen" : "")}></span>
                                                <span className="tooltipitemtext tooltipitemtext__right">Update the item name for displaying on the quote and invoice</span>
                                            </a>
                                            <a className={item.typeId === 50 || item.typeId === 51 ? "icon--cellwidth makeitgreen tooltipitem tooltipitem__right" : "hidden"} href="#" onClick={(e) => this.openFenceBracing(e, item.itemIndex)}>
                                                <span className="fas fa-calculator edit--icon alignIconCenter"></span>
                                                <span className="tooltipitemtext tooltipitemtext__right">Check/Calculate bracing required for fencing</span>
                                            </a>
                                            <a className={item.typeId > 57 && item.typeId < 62 && item.id > 0 ? "icon--cellwidth tooltipitem tooltipitem__right" : "hidden"} href="#" onClick={(e) => this.viewEpaQuestions(e, item.itemIndex)}>
                                                <span className="fa-solid fa-circle-question edit--icon alignIconCenter makeitgreen"></span>
                                                <span className="tooltipitemtext tooltipitemtext__right">Answer EPA Questions</span>
                                            </a>
                                        </td>
                                        <td className="table__text--align">
                                            {item.itemId === 4 || item.isWalkWay ?
                                                <div className="delete--tablecell">
                                                    <a className="makeitgreen" href="#" onClick={(e) => item.itemId === 4 ? this.calculateKwikstage(e, item.itemIndex) : this.checkWalkWayPitch(e, item.itemIndex)}>
                                                        <span className="fas fa-calculator edit--icon alignIconCenter"></span>
                                                    </a>
                                                </div> :
                                                <div className={this.props.systemCompanyId === 3 ? "hidden" : "delete--tablecell"}>
                                                    <a className={lastRowIndex != index ? !item.quoteNote ? "" : "makeitgreen" : "hidden"} href="#" onClick={(e) => this.addQuoteNotes(e, item.itemIndex)}>
                                                        <span className="fas fa-pencil-alt edit--icon alignIconCenter"></span>
                                                    </a>
                                                </div>
                                            }
                                        </td>
                                        <td className={this.props.systemCompanyId === 2 ? "table__text--align textaligncenter" : "hidden"}>
                                            <select className={item.isWalkWay ? "select table__select--size" : "hidden"} id="steepRoofPitch" name="steepRoofPitch" value={item.steepRoofPitch} onChange={(e) => this.onCellChange(lastRowIndex == index, item.itemIndex, "steepRoofPitch", Number(e.target.value))} disabled={item.statusId == 1 || item.statusId == 2 ? false : true}>
                                                <option value={1}>Yes</option>
                                                <option value={0}>No</option>
                                            </select>
                                        </td>
                                        <td className="table__text--align">
                                            {item.status}
                                            <button type="button" className={item.statusId === 9 ? "defaultbutton--green paddingFull5" : "hidden"} onClick={(e) => this.scheduleOnHoldJob(e, item.itemIndex, true)} >Schedule </button>
                                        </td>
                                        <td className="table__text--align">
                                            <input type='number' min="0" step="1" className={this.props.systemCompanyId === 3 && (!item.customHirePeriod || item.statusId > 2) ? "hidden" : "form-control textalignright"} value={item.hirePeriod} onChange={(e) => this.onCellChange(lastRowIndex == index, item.itemIndex, "hirePeriod", Number(e.target.value))} disabled={item.statusId == 1 || item.statusId == 2 ? false : true} />
                                            <select className={this.props.systemCompanyId === 3 && !item.isEvent && item.statusId <= 2 && !item.customHirePeriod ? "select table__select--size" : "hidden"} id="hirePeriod" name="hirePeriod" value={item.hirePeriod} onChange={(e) => this.onHireCellChange(lastRowIndex == index, item.itemIndex, e)} disabled={item.callout || (item.hirePeriod === 1 && !item.customHirePeriod) || item.typeId === 53 || item.statusId > 2}>
                                                <option hidden defaultValue="-1"></option>
                                                <option hidden={!item.callout && item.typeId != 26} value={1}>1 Day</option>
                                                <option hidden={item.defaultHirePeriod > 7 || item.invoicePeriodTypeId === 2} value={7}>1 Week</option>
                                                <option hidden={item.defaultHirePeriod > 14 || item.invoicePeriodTypeId === 2} value={14}>2 Weeks</option>
                                                <option hidden={item.defaultHirePeriod > 21 || item.invoicePeriodTypeId === 2} value={21}>3 Weeks</option>
                                                <option hidden={item.defaultHirePeriod > 28 || item.invoicePeriodTypeId === 2} value={28}>4 Weeks</option>
                                                <option hidden={item.defaultHirePeriod > 35 || item.invoicePeriodTypeId === 2} value={35}>5 Weeks</option>
                                                <option hidden={item.typeId === 19 || item.typeId === 23 || item.defaultHirePeriod > 42 || item.invoicePeriodTypeId === 2} value={42}>6 Weeks</option>
                                                <option hidden={item.typeId === 23 || item.typeId === 25 || item.typeId == 26 || item.defaultHirePeriod > 56 || item.invoicePeriodTypeId === 2} value={56}>8 Weeks</option>
                                                <option hidden={item.typeId === 19 || item.typeId === 23 || item.defaultHirePeriod > 70 || item.invoicePeriodTypeId === 2} value={70}>10 Weeks</option>
                                                <option hidden={item.invoicePeriodTypeId === 2} value={91}>13 Weeks</option>
                                                <option hidden={item.typeId === 23 || item.typeId === 50 || item.typeId === 51} value={98}>14 Weeks</option>
                                                <option hidden={item.typeId === 23 || item.typeId === 50 || item.typeId === 51} value={112}>16 Weeks</option>
                                                <option hidden={item.typeId != 25 || item.invoicePeriodTypeId === 2} value={140}>20 Weeks</option>
                                                <option value={item.invoicePeriodTypeId === 2 ? 6 : 182}>{item.invoicePeriodTypeId === 2 ? "6 Months" : "26 Weeks"}</option>
                                                <option hidden={item.typeId != 23} value={252}>36 Weeks</option>
                                                <option hidden={item.typeId != 25} value={280}>40 Weeks</option>
                                                <option value={item.invoicePeriodTypeId === 2 ? 12 : 364}>{item.invoicePeriodTypeId === 2 ? "12 Months" : "52 Weeks"}</option>
                                            </select>
                                            {this.props.systemCompanyId === 3 && !item.isEvent && item.statusId > 2 ? item.hirePeriodWeeksDesc : ""}
                                        </td>
                                        <td className={this.props.systemCompanyId === 3 ? "table__text--align" : "hidden"}>
                                            <div className={item.customHirePeriod || item.itemId < 1 || item.isEvent || (item.hirePeriod === 1 && !item.customHirePeriod) || item.typeId === 53 || item.statusId > 2 ? "hidden" : "tooltipitem tooltipitem__right"}><i className="fa-solid fa-pen-to-square" onClick={(e) => this.editCustomHirePeriod(e, item.itemIndex)}></i>
                                                <span className="tooltipitemtext tooltipitemtext__right">Enter Hire Period in Weeks</span>
                                            </div>
                                        </td>
                                        <td className={this.props.systemCompanyId === 3 ? "table__text--align" : "hidden"}>
                                            <select className={!item.item.toLowerCase().includes("sewer connect") && (item.typeId === 25 || item.typeId === 26 || (item.typeId > 57 && item.typeId < 61)) ? "select" : "hidden"} id="frequencyId" name="frequencyId" value={item.frequencyId} onChange={(e) => this.onCellChange(lastRowIndex == index, item.itemIndex, "frequencyId", Number(e.target.value))} disabled={item.statusId == 1 || item.statusId == 2 ? false : true}>
                                                <option defaultValue="-1"></option>
                                                {this.state.frequencyOptions.map(freq =>
                                                    <option key={freq.id} hidden={(item.typeId === 59 && (freq.id < 4 || freq.id > 8)) || (item.typeId === 58 && freq.id < 9) || ((item.typeId < 58 || item.typeId > 59) && freq.id > 3)} value={freq.id}>{freq.name}</option>
                                                )};
                                            </select>
                                            <input className={item.typeId === 38 || item.typeId === 61 ? 'form-control textalignright table-input--minwidth' : "hidden"} type='number' min="0" step="1" id="extraHours" name="extraHours" value={item.extraHours} onChange={(e) => this.onCellHoursChange(e, lastRowIndex == index, item.itemIndex)} disabled={item.statusId == 1 || item.statusId == 2 ? false : true} />

                                            <select className={item.typeId === 51 ? "select allocate__size130" : "hidden"} id="fenceBraceId" name="fenceBraceId" value={item.fenceBraceId} onChange={(e) => this.bracingChange(lastRowIndex == index, item.itemIndex, Number(e.target.value))} disabled={item.statusId == 1 || item.statusId == 2 ? false : true} >
                                                <option value={-1} defaultValue={-1}></option>
                                                <option value={1}>Brace Every Panel</option>
                                                <option value={2}>Brace Every 2nd Panel</option>
                                                <option value={3}>Brace Every 3rd Panel</option>
                                                <option value={4}>Brace Custom</option>
                                            </select>

                                            <select className={item.isEws ? "select" : "hidden"} id="truckId" name="truckId" value={item.truckId} onChange={(e) => this.onCellChange(lastRowIndex == index, item.itemIndex, "truckId", Number(e.target.value))} disabled={item.statusId == 1 || item.statusId == 2 ? false : true}>
                                                <option hidden defaultValue="-1"></option>
                                                {this.state.truckOptions.map(truck =>
                                                    <option key={truck.id} value={truck.id}>{truck.name}</option>
                                                )};
                                            </select>
                                        </td>
                                        <td className={this.props.systemCompanyId === 3 ? "table__text--align" : "hidden"}>
                                            <input type='number' min="0" step="1" className={item.productGroupId === 6 ? 'form-control textalignright table-input--minwidth100' : "hidden"} value={item.size} onChange={(e) => this.onCellChange(lastRowIndex == index, item.itemIndex, "size", Number(e.target.value))} disabled={(item.statusId == 1 || item.statusId == 2) && item.itemId != 4 ? false : true} />
                                            <select className={item.isEws && item.typeId != 21 ? "select" : "hidden"} id="truckDoorsId" name="truckDoorsId" value={item.truckDoorsId} onChange={(e) => this.onCellChange(lastRowIndex == index, item.itemIndex, "truckDoorsId", Number(e.target.value))} disabled={item.statusId == 1 || item.statusId == 2 ? false : true}>
                                                <option hidden defaultValue="-1"></option>
                                                {this.state.truckSideOptions.map(ts =>
                                                    <option key={ts.id} value={ts.id}>{ts.name}</option>
                                                )};
                                            </select>
                                        </td>
                                        <td className={this.props.systemCompanyId === 2 ? "table__text--align" : "hidden"}>
                                            <input type='number' min="0" step="1" className={item.isVoid ? 'form-control textalignright' : "hidden"} value={item.size} onChange={(e) => this.onCellChange(lastRowIndex == index, item.itemIndex, "size", Number(e.target.value))} disabled={(item.statusId == 1 || item.statusId == 2) && item.itemId != 4 ? false : true} />
                                            <select className={item.isTower ? "select" : "hidden"} id="size" name="size" value={item.size} onChange={(e) => this.onCellChange(lastRowIndex == index, item.itemIndex, "size", Number(e.target.value))} disabled={(item.statusId == 1 || item.statusId == 2) && item.itemId != 4 ? false : true}>
                                                <option hidden defaultValue="-1"></option>
                                                {this.state.towerSizeOptions.map(ts =>
                                                    <option key={ts} value={ts}>{ts}</option>
                                                )};
                                            </select>
                                        </td>
                                        <td className={this.props.systemCompanyId === 2 ? "table__text--align" : "hidden"}>
                                            <select className={item.isTower ? "select table__select--size" : "hidden"} id="includeInstallDismantle" name="includeInstallDismantle" value={item.includeInstallDismantle} onChange={(e) => this.onCellChange(lastRowIndex == index, item.itemIndex, "includeInstallDismantle", Number(e.target.value))} disabled={item.statusId == 1 || item.statusId == 2 ? false : true}>
                                                <option value={1}>Yes</option>
                                                <option value={0}>No</option>
                                            </select>
                                        </td>
                                        <td className="table__text--align">{item.isVoid ? "m2" : ""}</td>
                                        <td className="table__text--align"><input type='number' min="0" step="1" className='form-control table-input--minwidth textalignright' value={item.quantity} onChange={(e) => this.onCellChange(lastRowIndex == index, item.itemIndex, "quantity", Number(e.target.value))} disabled={(item.statusId == 1 || item.statusId == 2) && !(item.typeId === 58 && item.item.includes("Septic")) ? false : true} /></td>
                                        <td className="table__text--align">{item.unitOfMeasure}</td>
                                        <td className={this.props.systemCompanyId === 3 ? "table__text--align" : "hidden"}>
                                            <input type='number' min="0" step="0.01" className='form-control allocate__size100 textalignright' id="initialHire" name="initialHire" value={item.initialHire} onChange={(e) => this.onCellPriceItemChange(e, lastRowIndex == index, item.itemIndex)} disabled={(item.statusId == 1 || item.statusId == 2) ? false : true} />
                                        </td>
                                        <td className="table__text--align">
                                            <input type='number' min="0" step="0.01" className='form-control textalignright table-input--minwidth' id="travelAmount" name="travelAmount" value={item.travelAmount} onChange={(e) => this.onCellPriceItemChange(e, lastRowIndex == index, item.itemIndex)} disabled={(item.statusId == 1 || item.statusId == 2) && item.canEditTravel ? false : true} />
                                        </td>
                                        <td className={this.props.systemCompanyId === 3 ? "table__text--align" : "hidden"}>
                                            <input type='number' min="0" step="0.01" className='form-control allocate__size100 textalignright' id="cleaningFee" name="cleaningFee" value={item.cleaningFee} onChange={(e) => this.onCellPriceItemChange(e, lastRowIndex == index, item.itemIndex)} disabled={(item.statusId == 1 || item.statusId == 2) && (item.isEws || item.productGroupId === 6) ? false : true} />
                                        </td>
                                        <td className={this.props.systemCompanyId === 3 ? "table__text--align" : "hidden"}>
                                            <input type='number' min="0" step="0.01" className='form-control allocate__size100 textalignright' id="trenchFee" name="trenchFee" value={item.trenchFee} onChange={(e) => this.onCellPriceItemChange(e, lastRowIndex == index, item.itemIndex)} disabled={(item.statusId == 1 || item.statusId == 2) && item.isEws ? false : true} />
                                        </td>
                                        <td className={this.props.systemCompanyId === 3 && hasEpaItems ? "table__text--align" : "hidden"}>
                                            <input type='number' min="0" step="0.01" className='form-control allocate__size100 textalignright' id="confinedSpaceAmount" name="confinedSpaceAmount" value={item.confinedSpaceAmount} onChange={(e) => this.onCellPriceItemChange(e, lastRowIndex == index, item.itemIndex)} disabled={(item.statusId == 1 || item.statusId == 2) && item.typeId === 61 ? false : true} />
                                        </td>
                                        <td className={this.props.systemCompanyId === 3 && hasEpaItems ? "table__text--align" : "hidden"}>
                                            <input type='number' min="0" step="0.01" className='form-control allocate__size100 textalignright' id="sampleTestingAmount" name="sampleTestingAmount" value={item.sampleTestingAmount} onChange={(e) => this.onCellPriceItemChange(e, lastRowIndex == index, item.itemIndex)} disabled={(item.statusId == 1 || item.statusId == 2) && item.typeId === 61 ? false : true} />
                                        </td>
                                        <td className={this.props.systemCompanyId === 3 && hasEpaItems ? "table__text--align" : "hidden"}>
                                            <input type='number' min="0" step="0.01" className='form-control allocate__size100 textalignright' id="wasteDisposalAmount" name="wasteDisposalAmount" value={item.wasteDisposalAmount} onChange={(e) => this.onCellPriceItemChange(e, lastRowIndex == index, item.itemIndex)} disabled={(item.statusId == 1 || item.statusId == 2) && item.typeId === 61 ? false : true} />
                                        </td>
                                        <td className="table__text--align">
                                            <input type='number' min="0" step="0.01" className='form-control allocate__size100 textalignright' id="fuelSurchargeAmount" name="fuelSurchargeAmount" value={item.fuelSurchargeAmount} onChange={(e) => this.onCellPriceItemChange(e, lastRowIndex == index, item.itemIndex)} disabled={(item.statusId == 1 || item.statusId == 2) ? false : true} />
                                        </td>
                                        <td className={this.props.systemCompanyId === 2 ? "table__text--align" : "hidden"}>
                                            <input type='number' min="0" step="1" className='form-control textalignright table-input--minwidth' value={item.extraHours} onChange={(e) => this.onCellChange(lastRowIndex == index, item.itemIndex, "extraHours", Number(e.target.value))} disabled={(item.statusId == 1 || item.statusId == 2) && item.itemId != 4 && item.itemId != 25 && item.itemId != 33 && !item.isWalkWay ? false : true} />
                                        </td>
                                        <td className="hidden">{item.rate}</td>
                                        <td className="hidden">{item.gst}</td>
                                        <td className="table__text--align"><input type='number' min="0" step="0.01" className='form-control textalignright table-input--minwidth100' value={item.amount} onChange={(e) => this.onCellChangeNumber(lastRowIndex == index, item.itemIndex, "amount", e.target.value)} disabled={item.statusId == 1 || item.statusId == 2 ? false : true} /></td>
                                        <td className="table__text--align"><input type='number' min="0" step="0.01" className='form-control textalignright table-input--minwidth' value={item.overhireRate} onChange={(e) => this.onCellChangeNumber(lastRowIndex == index, item.itemIndex, "overhireRate", e.target.value)} disabled={item.statusId == 1 || item.statusId == 2 ? false : true} /></td>
                                        <td className={this.props.systemCompanyId === 2 ? "table__text--align textalignright" : "hidden"}>
                                            {item.estCostPriceFormatted}
                                        </td>
                                        <td className={this.props.systemCompanyId === 2 ? "table__text--align textalignright" : "hidden"}>
                                            {item.estMarginFormatted}
                                        </td>
                                        <td className={this.props.systemCompanyId === 2 ? "table__text--align textalignright" : "hidden"}>
                                            {item.estMarginPercentageFormatted }
                                        </td>
                                        <td className="table__text--align">
                                            {(item.statusId == 1 || item.statusId == 2) && lastRowIndex != index ?
                                                <div className="delete--tablecell tooltipitem tooltipitem__left">
                                                    <a className="makeitred" href="#" onClick={(e) => this.cancelItem(e, item.itemIndex)}>
                                                        <span className="fas fa-times-circle edit--icon alignIconCenter"></span>
                                                        <span className="tooltipitemtext tooltipitemtext__left">Remove item from Quote</span>
                                                    </a>
                                                </div> : ""
                                            }
                                        </td>
                                        <td className="table__text--align">
                                            <a className={!item.notes ? "hidden" : ""} data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => this.editNotes(e, item.itemIndex)}>
                                                <div className="tooltipitem tooltipitem__left">{item.notes ? item.notes.substring(0, 20) + "... " : ""}
                                                    <span className="tooltipitemtext tooltipitemtext__large tooltipitemtext__left">{item.notes}</span>
                                                </div>
                                            </a>
                                            <a className={!item.notes && lastRowIndex != index && item.id > 0 ? "icon--cellwidth tooltipitem tooltipitem__left" : "hidden"} data-toggle="modal" data-target="#notesModal" href="#" onClick={(e) => this.editNotes(e, item.itemIndex)}>
                                                <span className="fas fa-pencil-alt edit--icon alignIconCenter"></span>
                                                <span className="tooltipitemtext tooltipitemtext__left">Add/Edit Notes</span>
                                            </a>
                                        </td>
                                    </tr>
                                    
                            )}
                            </tbody>
                        </table>
                        {this.state.errors["quoteItems"] ?
                            (this.state.errors["quoteItems"]).split("\n").map((item: any, key: any) => {
                                return <span className="label errors" key={key}>{item}<br /></span>
                            })
                            : ""}
                    </div>
                    <div className="makeitflexspacebetween">
                        <label className={this.props.systemCompanyId === 3 ? "hidden" : "input-group--inline job__checkboxPosition"} htmlFor="showSiteVisitNote">
                            <span className="label">Job Quote - include Site Visit note</span>
                            <input type="checkbox" name="showSiteVisitNote" id="showSiteVisitNote" checked={this.state.quoteDetails.showSiteVisitNote} onChange={(e) => this.handleSiteVisitNoteChange(e)}></input>
                        </label>
                        <div className="marginTop10 alignitemscentre">
                            <span className="marginRight10">Upload Plans</span> <input type="file" name="file" accept="application/pdf" onChange={this.handleImportFile} multiple></input>
                        </div>
                        <div className="alignitemscentre">
                            <div className={this.state.plans.length > 0 ? "" : "hidden"}>
                                {this.state.plans.map((plan, index) =>
                                    <div key={plan.id}>
                                        <a href="#" onClick={(e) => this.downloadPlan(e, plan.id)}>{plan.fileName}</a>
                                        <button type="button" className="marginLeft10 close makeitred" onClick={() => this.deleteJobPlan(plan.id)} >&times;</button>
                                    </div>
                                )}
                                
                            </div>
                        </div>
                        <div className="input-group--inline job__quote--total--nomargin">
                            <span className="label-large job__quote--total">Total Amount Quoted</span>
                            <span className="job__quote--amount makeitflexright">{this.state.quoteDetails.totalQuotedAmountFormatted}</span>
                        </div>
                    </div>
                    <div className={this.props.systemCompanyId === 3 ? "makeitflexright" : "hidden"}>
                        <div className="input-group--inline job__quote--total--nomargin">
                            <a className="marginRight10" href="#" onClick={(e) => this.viewExtraInvoiceItems(e)}>Edit Extras</a>
                            <span className="label-large job__quote--total">Extra Invoice Amount</span>
                            <span className="job__quote--amount makeitflexright">{this.state.quoteDetails.totalInvoiceExtraAmountFormatted}</span>
                        </div>
                    </div>
                    <div className={this.props.systemCompanyId === 3 ? "makeitflexright" : "hidden"}>
                        <div className="input-group--inline job__quote--total--nomargin">
                            <span className="label-large job__quote--total">Total Invoice Amount</span>
                            <span className="job__quote--amount makeitflexright">{this.state.quoteDetails.totalInvoiceAmountFormatted}</span>
                        </div>
                    </div>
                    <div className="input-group-parent--row">
                        <button type="button" className={this.props.systemCompanyId === 3 ? "hidden" : "defaultbutton marginRight10"} onClick={this.addSiteNotes}>Add Site Notes</button>
                        <button className="defaultbutton" type="button" onClick={this.printJobQuote}>{jobQuoteHeading}</button>
                        <button className={this.props.systemCompanyId === 3 && hasEpaOtherItems ? "defaultbutton marginLeft10" : "hidden"} type="button" onClick={this.printJobQuoteSampleTesting}>Print Sample Testing</button>
                        <button className={this.props.systemCompanyId === 3 ? "hidden" : "defaultbutton marginLeft10"} type="button" onClick={this.printJobQuoteAcceptance} disabled={this.state.customerAccountTypeId != 1}>Print Acceptance</button>
                    </div>
                    <div className="input-group-parent">
                        <div className="colAlignRight">
                            <button className="defaultbutton defaultbutton__small marginRight10" type="button" onClick={this.copyJob}>Copy Job</button>
                            <button className="defaultbutton--save" type="button" onClick={this.submit}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}